function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawOrganizePhotos = function UndrawOrganizePhotos(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1006.44 815.08",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 406.23,
    y1: 807.5,
    x2: 406.23,
    y2: 60.35,
    gradientTransform: "matrix(-1 0 0 1 1096.85 0)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 411.27,
    y1: 423.16,
    x2: 411.27,
    y2: 188.22,
    gradientTransform: "matrix(-1 0 0 1 1000.07 -42.46)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 428.77,
    y1: 350.64,
    x2: 428.77,
    y2: 275.64,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 396.42,
    y1: 339.61,
    x2: 396.42,
    y2: 216.34,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 410.2,
    y1: 691.4,
    x2: 410.2,
    y2: 456.46,
    gradientTransform: "matrix(-1 0 0 1 1000.07 -42.46)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__f",
    x1: 1257.2,
    y1: 610.11,
    x2: 1257.2,
    y2: 518.16,
    gradientTransform: "translate(-517.15)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__g",
    x1: 618.87,
    y1: 481.79,
    x2: 618.87,
    y2: 246.86,
    gradientTransform: "matrix(0 -1 -1 0 860.59 1016.11)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__h",
    x1: 616.15,
    y1: 400.95,
    x2: 616.15,
    y2: 276.04,
    gradientTransform: "scale(-1 1) rotate(-7.5 328.924 8930.58)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__i",
    x1: 739.66,
    y1: 826.6,
    x2: 739.66,
    y2: 188.45,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M886.29 364.07c11.44 23.49 4.16 57.19 20.36 76.39 11.88 14.08 31.6 14 45.07 25.88 10.48 9.27 15.7 24.44 20.45 38.84l23.08 70c10.51 31.88 19.49 72.92-1.68 96.29-12.69 14-31.86 15.59-49.19 14.1-125.43-10.79-226.32-137.3-351.32-153.62-88.35-11.54-175.64 33.89-264.5 31.38-47-1.33-92.89-16-138.24-30.64-34.88-11.23-73.59-26-90.22-63.86-7.43-16.92-9.74-37.36-20.78-51.27-8.46-10.67-20.69-15.72-31.2-23.45C2.33 360.43-2.88 285 1.07 221.51c2.21-35.22 5.95-71.28 19.88-102.54s40.14-57.11 70.06-58.13c18.92-.65 37 8.37 55.41 13.41s40 5.19 53.82-10c11.34-12.47 14.9-32.5 26.24-45 8.83-9.71 21.15-13.48 33.06-15.79 64.05-12.43 132.29 9.08 182.51 57.65 12.17 11.79 23.84 25.43 38.76 31.43 19.87 8.05 41.59 1.23 62.6 1.4 74.12.6 124.39 80.82 176.63 131.39 30.54 29.57 60.08 35.94 93.22 55.64 20.52 12.22 60.66 57.71 73.03 83.1z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M873.72 683.28c4.29 9.21-1.85 19.15.28 28.66 2.69 12 18.11 21.34 34.72 27.3s35.16 9.58 51.35 16c7 2.77 14.3 7.88 10.66 12.58-1.26 1.63-3.62 2.77-5.93 3.84-47.16 21.76-105.45 33.58-163.69 33.2-61.6-.41-121.92-14-183.47-12.44-79.38 2-156.16 29.06-234.66 21.26-33.32-3.31-64.28-12.75-96.72-18.64-47.72-8.67-97.91-9.54-147.33-12.39-37.11-2.14-79.52-7.69-97.25-28.55-12.82-15.08-7.44-35 10.62-47.77s46.92-18.25 73.57-15.79c14.33 1.33 28.57 4.78 42.9 3.41 8.32-.8 16-3.18 23.59-5.52 58.71-18.2 119.53-36.36 184.7-39 106-4.33 204.25 32.55 307.52 48.5 16.08 2.48 33.54 4.39 48.73.23 16-4.39 26.5-14.76 42.53-19.13 7.61-2.08 16.09-2.68 23.57-4.94 20.56-6.22 11-14.77 39.54-9 14.91 3.05 29.97 7.91 34.77 18.19z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M813.02 382.08s-55.8 55.76-24.28 138.46-54 220.33-54 220.33.92-.13 2.61-.43c114.52-20.21 171.42-151.19 107.74-248.49-23.63-36.14-43.07-78.57-32.07-109.87z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M813.02 382.08s-55.8 55.76-24.28 138.46-54 220.33-54 220.33.92-.13 2.61-.43c114.52-20.21 171.42-151.19 107.74-248.49-23.63-36.14-43.07-78.57-32.07-109.87z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M813.02 382.08s-31.48 68.35 0 124.11 5.4 212.24-78.24 234.72",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M912.33 607.6s-63.63-10.13-69.43 46.89-122.34 64.93-122.34 64.93.76.52 2.19 1.45c96.23 63.17 188.22 40.24 174.35-43.64-5.16-31.19-4.74-62.51 15.23-69.63z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M912.33 607.6s-63.63-10.13-69.43 46.89-122.34 64.93-122.34 64.93.76.52 2.19 1.45c96.23 63.17 188.22 40.24 174.35-43.64-5.16-31.19-4.74-62.51 15.23-69.63z",
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M912.33 607.6s-49.39 10.84-45.33 55.75-73.34 98.74-146.44 56.07",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M534.13 60.35h313a31 31 0 0 1 31 30.9V776.6a31 31 0 0 1-31 30.9h-313a31 31 0 0 1-31-30.9V91.25a31 31 0 0 1 31-30.9z",
    transform: "translate(-96.78 -42.46)",
    fill: "url(#prefix__a)"
  }), React.createElement("rect", {
    x: 505.98,
    y: 66.08,
    width: 369.28,
    height: 738.56,
    rx: 26.87,
    ry: 26.87,
    transform: "rotate(-180 642.225 414.125)",
    fill: "#535461"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M751.28 693.47H436.39V92.32h314.89z"
  }), React.createElement("circle", {
    cx: 631.05,
    cy: 57.97,
    r: 2.86,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 650.54,
    y: 97.57,
    width: 62.98,
    height: 5.73,
    rx: 1,
    ry: 1,
    transform: "rotate(180 633.64 79.2)",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 595.27,
    cy: 722.1,
    r: 20.04,
    fill: "#fff"
  }), React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "M471.33 145.76h234.93v234.93H471.33z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M702.8 377.23H474.79V149.22H702.8z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M692.42 314.92H485.18v-155.3h207.24z"
  }), React.createElement("path", {
    d: "M607.22 236.18s8.25-3.8 11.07-10.31a13.76 13.76 0 0 1 5.77-6.52 23.14 23.14 0 0 1 3.85-1.75",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M629.66 213.54c-.8.7-1.86 4.19-1.86 4.19s3.6-.58 4.41-1.28a1.931 1.931 0 1 0-2.54-2.91zM623.11 215c-.29 1 .72 4.53.72 4.53s2.71-2.45 3-3.47a1.934 1.934 0 0 0-3.72-1.06zM615.59 221.75c.27 1 2.91 3.55 2.91 3.55s1.1-3.48.84-4.51a1.936 1.936 0 0 0-3.74 1zM611.06 228.14c.09 1.06 2.26 4 2.26 4s1.67-3.24 1.59-4.31a1.931 1.931 0 0 0-3.85.31zM626.34 222.72c-1.06-.09-4-2.27-4-2.27s3.24-1.67 4.31-1.59a1.932 1.932 0 1 1-.32 3.85zM620.94 230.13c-1-.4-3.13-3.36-3.13-3.36s3.59-.63 4.58-.23a1.931 1.931 0 0 1-1.45 3.58zM614.7 236.61c-1-.23-3.65-2.78-3.65-2.78s3.44-1.23 4.48-1a1.935 1.935 0 0 1-.83 3.78z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M629.66 213.54c-.8.7-1.86 4.19-1.86 4.19s3.6-.58 4.41-1.28a1.931 1.931 0 1 0-2.54-2.91zM623.11 215c-.29 1 .72 4.53.72 4.53s2.71-2.45 3-3.47a1.934 1.934 0 0 0-3.72-1.06zM615.59 221.75c.27 1 2.91 3.55 2.91 3.55s1.1-3.48.84-4.51a1.936 1.936 0 0 0-3.74 1zM611.06 228.14c.09 1.06 2.26 4 2.26 4s1.67-3.24 1.59-4.31a1.931 1.931 0 0 0-3.85.31zM626.34 222.72c-1.06-.09-4-2.27-4-2.27s3.24-1.67 4.31-1.59a1.932 1.932 0 1 1-.32 3.85zM620.94 230.13c-1-.4-3.13-3.36-3.13-3.36s3.59-.63 4.58-.23a1.931 1.931 0 0 1-1.45 3.58zM614.7 236.61c-1-.23-3.65-2.78-3.65-2.78s3.44-1.23 4.48-1a1.935 1.935 0 0 1-.83 3.78z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M538.38 270.77s-3.08 6.05-.57 9.36-.23 12.33-.23 12.33",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M537.47 268.88a1.23 1.23 0 1 0 .86-2.11 3.56 3.56 0 0 0-.86 2.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M536.79 270.77s3.08 6.05.57 9.36.23 12.33.23 12.33",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M537.7 268.88a1.23 1.23 0 1 1-.86-2.11 3.56 3.56 0 0 1 .86 2.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M537.7 268.88a1.23 1.23 0 1 1-.86-2.11 3.56 3.56 0 0 1 .86 2.11z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M535.53 270.77s-3.08 6.05-.57 9.36-.23 12.33-.23 12.33",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M534.62 268.88a1.23 1.23 0 1 0 .86-2.11 3.56 3.56 0 0 0-.86 2.11zM535.1 273.73a3.56 3.56 0 0 0 2.08.93 3 3 0 0 0-2.93-3 3.56 3.56 0 0 0 .85 2.07zM535.02 277.9a3.56 3.56 0 0 0 2.08.93 3 3 0 0 0-2.93-3 3.56 3.56 0 0 0 .85 2.07zM539.4 280.2a3.56 3.56 0 0 0-.74 2.16 3 3 0 0 0 2.77-3.19 3.56 3.56 0 0 0-2.03 1.03zM538.69 271.3a3.56 3.56 0 0 0-1.29 1.88 3 3 0 0 0 3.52-2.33 3.56 3.56 0 0 0-2.23.45z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M538.69 271.3a3.56 3.56 0 0 0-1.29 1.88 3 3 0 0 0 3.52-2.33 3.56 3.56 0 0 0-2.23.45z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M533.93 270.77s3.08 6.05.57 9.36.23 12.33.23 12.33",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M534.84 268.88a1.23 1.23 0 1 1-.86-2.11 3.56 3.56 0 0 1 .86 2.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M534.84 268.88a1.23 1.23 0 1 1-.86-2.11 3.56 3.56 0 0 1 .86 2.11z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M534.6 273.82a3.56 3.56 0 0 1 .87 2.11 3 3 0 0 1-3-3 3.56 3.56 0 0 1 2.13.89z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M534.6 273.82a3.56 3.56 0 0 1 .87 2.11 3 3 0 0 1-3-3 3.56 3.56 0 0 1 2.13.89z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M532.99 279.6a3.56 3.56 0 0 1 .87 2.11 3 3 0 0 1-3-3 3.56 3.56 0 0 1 2.13.89z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M535.36 278.33s-1.86-2.92-4.46-3M536.8 276.54s1.86-2.92 4.46-3M537.04 280.74s-1.86-2.92-4.46-3",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("circle", {
    cx: 530.98,
    cy: 275.32,
    r: 0.48,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 541.21,
    cy: 273.59,
    r: 0.48,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M535.68 281.7s1.86-2.92 4.46-3",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("circle", {
    cx: 540.09,
    cy: 278.73,
    r: 0.48,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 532.54,
    cy: 277.77,
    r: 0.48,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M525.42 288.94s4.47-.89 5.66-2.09 6.56-3.28 7.15-1.79 8 6.56 3 7.45-11.92 1.19-13.41.6-2.4-4.17-2.4-4.17z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M541.22 291.97c-5.07.89-11.92 1.19-13.41.6-1.14-.45-1.92-2.64-2.24-3.65h-.15s.89 3.58 2.38 4.17 8.35.3 13.41-.6c1.46-.26 1.88-.86 1.72-1.63-.11.53-.62.91-1.71 1.11z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M641.93 280.6s-1.48 1.93.68 4.84 3.94 5.37 3.22 7.19c0 0-3.26-5.41-5.9-5.49s-.91-3.29 2-6.54z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M641.93 280.6a2.39 2.39 0 0 0-.3.61c-2.59 3-4 5.87-1.48 5.94 2.31.07 5.09 4.21 5.76 5.25a2.24 2.24 0 0 1-.08.24s-3.26-5.41-5.9-5.49-.91-3.3 2-6.55z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M639.22 283.06c0 .68.08 1.23.17 1.23s.17-.55.17-1.23-.1-.36-.19-.36-.15-.32-.15.36z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M638.22 283.87c.6.33 1.12.52 1.16.44s-.4-.41-1-.74-.36-.09-.41 0-.32-.03.25.3z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M649.73 280.6s1.48 1.93-.68 4.84-3.94 5.37-3.22 7.19c0 0 3.26-5.41 5.9-5.49s.91-3.29-2-6.54z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M649.73 280.6a2.39 2.39 0 0 1 .3.61c2.59 3 4 5.87 1.48 5.94-2.31.07-5.09 4.21-5.76 5.25a2.24 2.24 0 0 0 .08.24s3.26-5.41 5.9-5.49.91-3.3-2-6.55z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M652.47 283.06c0 .68-.08 1.23-.17 1.23s-.17-.55-.17-1.23.1-.36.19-.36.15-.32.15.36z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M653.41 283.87c-.6.33-1.12.52-1.16.44s.4-.41 1-.74.36-.09.41 0 .35-.03-.25.3z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M652 292.38s-4.13-.13-5.37-1-6.35-1.94-6.66-.52-6.2 7.06-1.54 7.1 10.83-.73 12.07-1.48 1.5-4.1 1.5-4.1z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M638.35 297.45c4.66 0 10.83-.73 12.07-1.48.95-.58 1.32-2.64 1.45-3.6h.14s-.26 3.33-1.5 4.08-7.41 1.52-12.07 1.48c-1.35 0-1.81-.49-1.78-1.2.17.45.69.72 1.69.72z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M639.22 316a6.65 6.65 0 0 0 1.69 2.12 9 9 0 0 0 7.63 2.16 7.11 7.11 0 0 0 .86-.26c2.06 3.9.62 10.52.62 10.52l-.23 3.32a9.43 9.43 0 0 0 1.23.81l-.07.27-.14.58c-1.92 11.05 8.35 12.16 8.35 12.16s10.6 2.21 18.61 1.55a37.15 37.15 0 0 1 10.92.78c.61.13 1.15.27 1.62.4a6.66 6.66 0 0 0 2.62.17 6.38 6.38 0 0 0 1.09-.25 6.15 6.15 0 0 0 1.44-.67l.17-.11h.05l.12-.08h.05l.14-.1.14-.12.09-.08.09-.09.11-.12.06-.08v-.05l.06-.08.08-.11v-.26c1.37-2.43-1.21-5.06-1.21-5.06a17 17 0 0 0-10.27-3.32h-.77l-.08-.14-.1-.21h.06l-.14-.14c-.07-.15-.13-.31-.18-.47l.06-.08-.11-.05-.12-.37.05-.08-.1-.08q-.06-.21-.11-.42l.06-.09-.1-.06c0-.16-.07-.31-.1-.46l.06-.11-.09-.06v-.19l.07-.1-.09-.05c0-.13 0-.27-.06-.39l.06-.1-.08-.06v-.48l.08-.1-.09-.05v-.47a.55.55 0 0 0-.53-.52h-.26c0-.3.06-.88.13-1.75v-.72q.09-1 .23-2.46l.08-.82v-5.24l.06-.5v-.16l.06-.55c.3-2.55-.2-4.05-1-4.91v-.18l.22.13.44.24.2.11.18.09.38.19.14.07.14.07.16.08.12.06h.1l.11.05.12.05H684.76c0-.09 0-.18.07-.27V318v-.24-.32-.21-.28-.18V316.36l-.07-.18-.07-.14-.09-.16-.09-.13-.11-.14-.11-.12-.13-.13-.13-.11-.15-.11-.15-.1-.17-.1-.17-.09-.36-.17a7.42 7.42 0 0 0-1.54-.45c-1-2.49-5.16-.14-5.16-.14v.51h-.22l-5.3.69a4.93 4.93 0 0 1-.6-1.44 44.12 44.12 0 0 0-3.25-7.74 12.22 12.22 0 0 0-3.23-6l-.09-.32a22.64 22.64 0 0 1-.63-3 5.54 5.54 0 0 0 .81-3.46 6.54 6.54 0 0 0 4.59-6.2 6.42 6.42 0 0 0-.13-1.3 1.67 1.67 0 0 0 1-1c.34-1.17-.81-3.53-1.31-4.56l-.16-.32a6.38 6.38 0 0 0-8.17-3.55 9.54 9.54 0 0 0-6.12 5.78 2.78 2.78 0 0 1-1 1.62 5 5 0 0 0-.78.39 1.25 1.25 0 0 0-.37.74 28.14 28.14 0 0 0-2.92 2.54 18.58 18.58 0 0 1-1.88 1.77c-1.48 1.12-3.39 1.64-4.77 2.88a8.33 8.33 0 0 0-2.35 6.28c0 2.29.52 4.56.68 6.85a9.88 9.88 0 0 1-1.47 6.59 9.2 9.2 0 0 0-1.15 1.63 3.27 3.27 0 0 0 1.71 2.53zm36.18 1.7l-.11-.06.37-.13zm-6.16 17.44c3.71-2.69 8.54-9.24 8.54-9.24a42.73 42.73 0 0 0 .34 4.42v.69c.15.94.3 2.26.38 2.92a.36.36 0 0 0-.3.35l-.08 3.85v.22a84.37 84.37 0 0 1-8.88-3.21z",
    transform: "translate(-96.78 -42.46)",
    fill: "url(#prefix__c)"
  }), React.createElement("path", {
    d: "M568.04 287.89c.19 3 .85 6.11 2.82 5.34a7.13 7.13 0 0 0 1.56-.91c3.57-2.64 8.23-9.09 8.23-9.09a42.86 42.86 0 0 0 .33 4.35c.22 1 .54 4 .54 4h4s.22-3.91 1.2-12.39-6.85-5.22-6.85-5.22l-7.3 5.62-4.55 3.51s0 .67-.06 1.66.01 2 .08 3.13z",
    fill: "#8c8296"
  }), React.createElement("path", {
    d: "M568.04 287.89c.19 3 .85 6.11 2.82 5.34a7.13 7.13 0 0 0 1.56-.91c3.57-2.64 8.23-9.09 8.23-9.09a42.86 42.86 0 0 0 .33 4.35c.16.7.37 2.45.47 3.4 0 .38.07.62.07.62h4v-.47c.09-1.26.38-5.13 1.17-11.92 1-8.48-6.85-5.22-6.85-5.22l-7.3 5.62-4.55 3.51s0 .67-.06 1.66.04 1.98.11 3.11z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M581.44 290.98c0 .38.07.62.07.62h4v-.47l-4-.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M581.08 296.28l7 1.3a4.28 4.28 0 0 1-.68-1 12.79 12.79 0 0 1-1-4.7.53.53 0 0 0-.51-.51l-4.25-.18a.35.35 0 0 0-.37.35l-.08 3.78z",
    fill: "#e7c4c3"
  }), React.createElement("path", {
    d: "M581.08 296.28l7 1.3a4.28 4.28 0 0 1-.68-1 29.67 29.67 0 0 1-6.25-1.26z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M562.71 304.64s10.22 2.17 17.93 1.52a35.33 35.33 0 0 1 12.08 1.16 6.11 6.11 0 0 0 5-.73c4.07-2.65.35-6.52.35-6.52a16.19 16.19 0 0 0-9.89-3.26c-4.89 0-12.81-3.23-15.72-4.5l-1.12-.5-.45-5.56-.2-2.49-2.67 1-12.59 4.78-.62 2.58-.14.57c-1.85 10.85 8.04 11.95 8.04 11.95z",
    fill: "#8c8296"
  }), React.createElement("path", {
    d: "M554.67 292.69l.14-.57.62-2.58.4-.15-.48 2-.14.57c-1.85 10.87 8 12 8 12s10.22 2.17 17.93 1.52a35.33 35.33 0 0 1 12.08 1.06 6.11 6.11 0 0 0 5-.73 5.22 5.22 0 0 0 1-.83 4.37 4.37 0 0 1-1.55 1.6 6.11 6.11 0 0 1-5 .73 35.33 35.33 0 0 0-12.08-1.16c-7.72.65-17.93-1.52-17.93-1.52s-9.84-1.09-7.99-11.94z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M558.22 256.06l7 .86 3.37 1.09s-.1-.3-.25-.81c-.52-1.88-1.55-6.58.25-9.4 2.28-3.59-6 0-6 0a8.53 8.53 0 0 1-3.24 7.34 12.07 12.07 0 0 1-1.09.83zM574.56 272.54l9.89-1.3s5.76.11 4.56 4.56a26.83 26.83 0 0 1-5.11-2.83l-6.74 2.5z",
    fill: "#ffc7d1"
  }), React.createElement("path", {
    d: "M574.56 272.54l2.61 2.93 3.49-1.29 3.25-1.21c.56.4 1.12.76 1.65 1.08a25.83 25.83 0 0 0 3.46 1.75c.89-3.3-2.05-4.22-3.63-4.47a7.49 7.49 0 0 0-.93-.1l-4 .52z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 566.62,
    cy: 244.76,
    r: 6.41,
    fill: "#ffc7d1"
  }), React.createElement("path", {
    d: "M554.81 292.12c2.24 1.38 8.25 4 13-4l.22-.23a6.83 6.83 0 0 1 2.81-1.63 5.73 5.73 0 0 1 2-.2 36.86 36.86 0 0 1-.29-4.21c0-.71 0-1.47.06-2.23l-4.55 3.51s0 .67-.06 1.66l-12.57 4.75zM558.29 256.07l7 .86 3.37 1.09s-.1-.3-.25-.81l-.15-.15a6.69 6.69 0 0 0-3.87-2.07 8.29 8.29 0 0 1-1.37-.23 4.78 4.78 0 0 0-3.58.38 4.92 4.92 0 0 0-1.09.83z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M553.91 287.8l-.22 3.26s7.93 6.63 13.91-3.37a6.47 6.47 0 0 1 5-2.07 36.86 36.86 0 0 1-.29-4.21 24.3 24.3 0 0 1 .29-4.26c.41-2.41-.18-8-.66-11.77l-.14-1a12.14 12.14 0 0 0-3.51-7.08 6.69 6.69 0 0 0-3.87-2.07 8.29 8.29 0 0 1-1.37-.23c-1.29-.35-4.27-.62-6.1 3.37-2.39 5.22-2.61 7-2.61 7s-4.48 7.85-1.74 11.09c2.99 3.46 1.31 11.34 1.31 11.34z",
    fill: "#ffe09c"
  }), React.createElement("path", {
    d: "M580.47 271.8l.19 2.42 3.25-1.21c.56.4 1.12.76 1.65 1.08a6.71 6.71 0 0 0 0-2.16 2.62 2.62 0 0 0-.15-.56 7.49 7.49 0 0 0-.93-.1z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M578.47 280.73l2.11-1 1.69-.82 2.17-2a5.7 5.7 0 0 0 1.3-5c-.54-3.26-5.11-.65-5.11-.65l.33 4.24a1.59 1.59 0 0 1-.83.63 4 4 0 0 1-1 .24z",
    fill: "#ffc7d1"
  }), React.createElement("path", {
    d: "M543.33 270.85a9 9 0 0 1 1.11-1.61 9.87 9.87 0 0 0 1.42-6.48c-.15-2.25-.66-4.48-.65-6.73a8.28 8.28 0 0 1 2.26-6.17c1.33-1.22 3.16-1.73 4.59-2.83a18.05 18.05 0 0 0 1.81-1.74 27.28 27.28 0 0 1 2.81-2.5 1.24 1.24 0 0 1 .36-.73 4.73 4.73 0 0 1 .76-.38 2.74 2.74 0 0 0 .95-1.6 9.27 9.27 0 0 1 5.9-5.68 6.66 6.66 0 0 1 4.68.13 6.94 6.94 0 0 1 3.24 3.45c.48 1 1.59 3.34 1.26 4.48s-1.57 1.36-2.65 1.35c-.34.33-.72.66-1 1a7.06 7.06 0 0 0-1.09 1.39c-.72 1.32-.53 2.93-.46 4.44s-.11 3.22-1.29 4.16a8.24 8.24 0 0 1-1.06.65c-2.63 1.52-4.14 4.44-5 7.35s-1.31 6-2.48 8.77-3.31 5.45-6.27 6.15a8.57 8.57 0 0 1-7.41-2.18c-1.37-1.14-2.51-3-1.79-4.69z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M543.22 270.64a9 9 0 0 1 1.11-1.61 9.87 9.87 0 0 0 1.42-6.48c-.15-2.25-.66-4.48-.65-6.73a8.28 8.28 0 0 1 2.26-6.17c1.33-1.22 3.16-1.73 4.59-2.83a18.05 18.05 0 0 0 1.81-1.74 27.28 27.28 0 0 1 2.81-2.5 1.24 1.24 0 0 1 .36-.73 4.73 4.73 0 0 1 .76-.38 2.74 2.74 0 0 0 .95-1.6 9.27 9.27 0 0 1 5.9-5.68 6.66 6.66 0 0 1 4.68.13 6.94 6.94 0 0 1 3.24 3.45c.48 1 1.59 3.34 1.26 4.48s-1.57 1.36-2.65 1.35c-.34.33-.72.66-1 1a7.06 7.06 0 0 0-1.09 1.39c-.72 1.32-.53 2.93-.46 4.44s-.11 3.22-1.29 4.16a8.24 8.24 0 0 1-1.06.65c-2.63 1.52-4.14 4.44-5 7.35s-1.31 6-2.48 8.77-3.31 5.45-6.27 6.15a8.57 8.57 0 0 1-7.35-2.13c-1.42-1.19-2.56-3.09-1.85-4.74z",
    fill: "#ad5975"
  }), React.createElement("path", {
    d: "M564.89 272.79c1.92 2.95 4.87 7 7.43 8.62a24.3 24.3 0 0 1 .29-4.26c.41-2.41-.18-8-.66-11.77-.92-1.93-1.73-3.45-1.73-3.45s-3.75-2.93-6 1.89a9.25 9.25 0 0 0 .67 8.97zM578.47 280.73l2.11-1a3.94 3.94 0 0 0-.44-3.56 4 4 0 0 1-1 .24z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M564.64 263.39a9.23 9.23 0 0 0 .68 9c2.28 3.49 6 8.56 8.81 9.26 4.35 1.09 4.89.87 4.89.87s3.15-4.24.54-6.74c0 0-4-1.41-4.78-4.67s-4.13-9.56-4.13-9.56-3.75-3.01-6.01 1.84z",
    fill: "#ffe09c"
  }), React.createElement("path", {
    d: "M571.35 291.76s.33 1.09-2.39 2.17-4.35 4.56-4.35 4.56",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M587.33 296.85l.05-.1-.9-.49.46-.62-.78-.37.47-.69-.59-.39.42-.57-.74-.41.6-.76-.71-.41-.05.1.6.35-.6.76.74.4-.41.57.59.39-.48.71.78.37-.46.6 1.01.56z"
  }), React.createElement("path", {
    d: "M586.63 296.78l.57-.46-.73-.7.31-.47-.64-.52.36-.68-.46-.3.33-.57-.65-.51.52-.58-.08-.07-.6.67.67.52-.34.57.47.31-.35.67.62.52-.3.45.7.68-.47.39.07.08z"
  })), React.createElement("path", {
    fill: "#8c8296",
    d: "M587.44 296.85l.05-.1-.9-.49.46-.62-.78-.37.47-.69-.59-.39.42-.57-.74-.41.6-.76-.71-.41-.05.1.6.35-.6.76.74.4-.41.57.59.39-.49.71.78.37-.45.6 1.01.56z"
  }), React.createElement("path", {
    fill: "#8c8296",
    d: "M586.74 296.78l.56-.46-.72-.7.3-.47-.63-.52.36-.68-.46-.3.33-.57-.65-.51.52-.58-.08-.07-.6.67.67.52-.34.57.47.31-.35.67.62.52-.3.45.7.68-.47.39.07.08z"
  }), React.createElement("path", {
    d: "M560.22 243.02a2.74 2.74 0 0 1-.95 1.6 4.73 4.73 0 0 0-.76.38 1.24 1.24 0 0 0-.36.73 27.28 27.28 0 0 0-2.81 2.5 18.05 18.05 0 0 1-1.81 1.74c-1.43 1.1-3.26 1.61-4.59 2.83a8.28 8.28 0 0 0-2.26 6.17c0 2.26.5 4.48.65 6.73a9.87 9.87 0 0 1-1.42 6.48 9 9 0 0 0-1.11 1.61 2.71 2.71 0 0 0-.22 1.11c-1.13-1.18-1.93-2.81-1.3-4.27a9 9 0 0 1 1.11-1.61 9.87 9.87 0 0 0 1.42-6.48c-.15-2.25-.66-4.48-.65-6.73a8.28 8.28 0 0 1 2.26-6.17c1.33-1.22 3.16-1.73 4.59-2.83a18.05 18.05 0 0 0 1.81-1.74 27.28 27.28 0 0 1 2.81-2.5 1.24 1.24 0 0 1 .36-.73 4.73 4.73 0 0 1 .76-.38 2.74 2.74 0 0 0 .95-1.6 9.27 9.27 0 0 1 5.9-5.68c1.56-.47-3.38 6.17-4.38 8.84z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M687 289.89l.11.55 1.27 6.21 1.53 8.09s.77 4.59 0 5.61 1.63 14.89 1.63 14.89l.91 6.35v.16a2.45 2.45 0 0 0-.65.84 9.52 9.52 0 0 1-1.72 3.86 1.78 1.78 0 0 0-.39 1.17 1.9 1.9 0 0 0 1.94 1.86h3.64a2 2 0 0 0 1.57-.76l.89-1.16a1.89 1.89 0 0 0 .39-1.24 1.86 1.86 0 0 0-.1-.57 14.14 14.14 0 0 1-.82-3.58 1 1 0 0 0-.3-.66v-.21c-.26-2.12-.54-5.62.24-6.93s.49-8.09.22-12.06a21.92 21.92 0 0 1 .59-6.72c.11-.44.22-.87.34-1.26.35-1.19-.2-7.64-.68-12.42l-.05-.53a3.71 3.71 0 0 0 .45-.18 8.72 8.72 0 0 1 2.85-.73l-.06.56c-.5 4.83-1.16 12.13-.78 13.41.14.45.27 1 .4 1.5a21.06 21.06 0 0 1 .54 6.36c-.27 3.95-.6 10.82.21 12.18s.5 4.83.24 6.95v.21a1.08 1.08 0 0 0-.3.69 14.85 14.85 0 0 1-.88 3.7 1.51 1.51 0 0 0-.08.5 1.53 1.53 0 0 0 .32 1l1 1.32a2 2 0 0 0 1.57.76h3.64a1.9 1.9 0 0 0 1.94-1.86 1.78 1.78 0 0 0-.39-1.17 9.52 9.52 0 0 1-1.72-3.86 2.45 2.45 0 0 0-.65-.84v-.16l.91-6.35s2.4-13.88 1.63-14.89 0-5.61 0-5.61l1.53-8.09 1-5 .11-.55H712.71l.14-.05h.08l.12-.07h.07l.1-.08.06-.05.08-.09.05-.06.06-.1v-.07a3.46 3.46 0 0 1 3-1.81h1.08v-.25a170.3 170.3 0 0 0-2.5-9.6 12.27 12.27 0 0 0 .27-1.87l-.67-15.7a9.22 9.22 0 0 0 1.72-.47s.43-4 .41-7.77c0-3.26-.28-6.44-1.47-6.75a8.13 8.13 0 0 0-1.07-.17v-.19c-.62-4.84-1.32-5.22-7-6.08-3.22-.49-4.47-2.15-4.95-3.6v-.15a6.27 6.27 0 0 0 1.11-1 7.14 7.14 0 0 0 2.83-5.66 7 7 0 0 0-.48-2.56 3.89 3.89 0 0 0-1.66-3.18l-.24-.16a3.9 3.9 0 0 1 1.36 2.25 7.51 7.51 0 0 0-3.62-3.05 3.82 3.82 0 0 0 .71-2.22 4.12 4.12 0 0 0-8.24 0 3.81 3.81 0 0 0 .6 2 4 4 0 0 1-.39-.55 3.86 3.86 0 0 1 1.33-5.24l-.26.13a3.87 3.87 0 0 0-1.58 5.38 4 4 0 0 0 .85 1 7.19 7.19 0 0 0-3.52 6.13 7 7 0 0 0 1.63 4.5 4.27 4.27 0 0 1-4.41 0l.22.17a4.27 4.27 0 0 0 4.53.24q.26.27.54.51a6.32 6.32 0 0 0 2.67 1.93v.17c-.78 2.74-3.94 3.9-5.85 4.36a5.15 5.15 0 0 0-4.05 5.32v.18a3 3 0 0 0-1.29.52c-.57.59-.72 3.49-.71 6.46 0 3.62.23 7.51.23 7.51.27-.59 1.21-.9 2.3-1-.08 2.15-.19 4-.19 4l-2.2 14s-2.11 5.33-.77 5.7a.77.77 0 0 0 .65-.2c-.72 3.79-1.13 6.63-1.13 6.63s1.93-.61 3.74-.63zm23.53-23.06a12 12 0 0 1-.88-7.37 5 5 0 0 1 .59.2 62.27 62.27 0 0 1 .3 7.17z",
    transform: "translate(-96.78 -42.46)",
    fill: "url(#prefix__d)"
  }), React.createElement("path", {
    d: "M603.22 262.04c.13.45.26 1 .38 1.5a21.87 21.87 0 0 1 .52 6.34c-.25 3.94-.57 10.79.2 12.14s.48 4.81.23 6.93c-.12 1-.23 1.69-.23 1.69l4.31-.46.14-1 .87-6.33s2.29-13.84 1.56-14.84 0-5.59 0-5.59l1.47-8.06 1-5 1.13-5.74-10.35.73s-.2 1.83-.45 4.32c-.5 4.82-1.13 12.1-.78 13.37zM590.04 243.54l.89 4.53 1.22 6.19 1.47 8.06s.73 4.58 0 5.59 1.56 14.84 1.56 14.84l.87 6.33.14 1 4.31.46s-.11-.7-.23-1.71c-.25-2.12-.51-5.6.23-6.91s.46-8.07.21-12a22.75 22.75 0 0 1 .57-6.7c.11-.44.21-.87.32-1.25.34-1.19-.19-7.62-.65-12.39-.28-3-.54-5.3-.54-5.3z",
    fill: "#ffbcc8"
  }), React.createElement("circle", {
    cx: 601.49,
    cy: 178.11,
    r: 3.94,
    fill: "#40243e"
  }), React.createElement("path", {
    d: "M598.78 174.54l.24-.13a3.94 3.94 0 0 0 3.84 6.85l-.23.14a3.94 3.94 0 0 1-3.85-6.87zM592.22 191.64l-.21-.17a3.94 3.94 0 0 0 4.68-6.31l.23.16a3.942 3.942 0 0 1-4.7 6.33zM602.43 187.61l-.21-.17a3.94 3.94 0 0 0 4.68-6.31l.23.16a3.942 3.942 0 0 1-4.7 6.33z",
    fill: "#40243e"
  }), React.createElement("circle", {
    cx: 601.95,
    cy: 187,
    r: 7.24,
    fill: "#40243e"
  }), React.createElement("path", {
    d: "M587.65 241.34c1.28.37 3.67-5.5 3.67-5.5l4.58-13.93-.14-4.86-.32-10.51 13.65.37s2.57 6.6 3.48 8.43a5.26 5.26 0 0 1 .37 1.38 64.73 64.73 0 0 1 .36 8.7l1 9.8s.09 4.86 1.74 3.94 1.83-4.76 1.83-4.76l-.65-15.79v-.54a109.86 109.86 0 0 0-.3-13.57q-.06-.58-.12-1.09c-.59-4.83-1.26-5.2-6.66-6.06-3.08-.49-4.28-2.15-4.73-3.59a5.66 5.66 0 0 1-.22-2.37s-6.23-4.86-5.5 1a5.31 5.31 0 0 1-.12 2.08c-.75 2.74-3.77 3.89-5.6 4.34a5.11 5.11 0 0 0-3.88 5.3 7.81 7.81 0 0 0 .34 1.79 45.26 45.26 0 0 0 .18 5.5 49.06 49.06 0 0 1 0 5.64c-.08 2.41-.2 4.62-.2 4.62l-2.11 13.93s-1.93 5.38-.65 5.75z",
    fill: "#ffbcc8"
  }), React.createElement("path", {
    d: "M599.63 194.48a6 6 0 0 0 5.84-.72 5.66 5.66 0 0 1-.22-2.37s-6.23-4.86-5.5 1a5.31 5.31 0 0 1-.12 2.09z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 601.9,
    cy: 188.69,
    r: 6.05,
    fill: "#ffbcc8"
  }), React.createElement("path", {
    d: "M604.33 290.63l4.31-.46.14-1a4.85 4.85 0 0 0-2.15-1c-.35-.12-1.21.28-1.8.59a1 1 0 0 0-.26.2c-.13.98-.24 1.67-.24 1.67z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M606.62 288.34s2.11.37 2.75 1.83a9.72 9.72 0 0 0 1.65 3.85 1.86 1.86 0 0 1-1.48 3h-3.48a1.86 1.86 0 0 1-1.5-.76l-1-1.32a1.57 1.57 0 0 1-.22-1.43 15.33 15.33 0 0 0 .84-3.69 1.08 1.08 0 0 1 .57-.91c.66-.29 1.52-.69 1.87-.57z",
    fill: "#dfd5e3"
  }), React.createElement("path", {
    d: "M596.04 289.08l.14 1 4.31.46s-.11-.7-.23-1.71a1 1 0 0 0-.22-.15c-.59-.31-1.48-.73-1.84-.61a4.85 4.85 0 0 0-2.16 1.01z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M598.22 288.25s-2.11.37-2.75 1.83a9.72 9.72 0 0 1-1.65 3.85 1.86 1.86 0 0 0 1.48 3h3.48a1.86 1.86 0 0 0 1.5-.76l.85-1.16a1.94 1.94 0 0 0 .28-1.76 14.6 14.6 0 0 1-.79-3.57 1 1 0 0 0-.53-.84c-.64-.3-1.54-.71-1.87-.59z",
    fill: "#dfd5e3"
  }), React.createElement("path", {
    d: "M604.42 244.36s-.2 1.83-.45 4.32c1.92-.23 3.87-.07 4.29-.19s3.21.79 5.38.89l1.13-5.74zM590.04 243.54l.89 4.53a5.16 5.16 0 0 1 2.68.42c.87.78 4.95 2 7.32 1.08-.28-3-.54-5.3-.54-5.3z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M613.77 213.76s-3.39 5 0 11.73 6.32 20.62 6.32 20.62-3.12-.27-3.94 1.83-7.24-.18-7.88 0-4.67-.27-7 .92-6.78-.09-7.7-.92-6.41-.18-6.41-.18 2.93-21.44 7.06-25.11c0 0 2.47-3-.64-8.06s20.19-.83 20.19-.83z",
    fill: "#ff808e"
  }), React.createElement("path", {
    d: "M590.49 205.97a45.26 45.26 0 0 0 .18 5.5 49.06 49.06 0 0 1 0 5.64 14.27 14.27 0 0 1 3.83 0 3.84 3.84 0 0 0 1.23-.09c1.5-.28 3.78-1 4.45-1.83.92-1.1 3.85.73 4.49 1.19s4.49.64 5.5.18a3.6 3.6 0 0 1 2.75.1 5.18 5.18 0 0 1 1.46.91 3.45 3.45 0 0 0 2.86.47 109.86 109.86 0 0 0-.3-13.57q-.06-.58-.12-1.09c-3.86-.43-14.26-.29-14.26-.29s-9 .2-12.43 1a7.81 7.81 0 0 0 .36 1.88z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 601.54,
    cy: 184.53,
    rx: 5.54,
    ry: 3.21,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 601.54,
    cy: 184.34,
    rx: 5.54,
    ry: 3.21,
    fill: "#40243e"
  }), React.createElement("path", {
    d: "M611.98 198.32c-.18 0-4.95 0-5.77-.18M598.15 199.23a16.54 16.54 0 0 1-3.76-.18",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M605.59 202.54s-2.41 1.26-2.52 2.54c0 0-.9-2.38-2.17-2.49",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M603.63 294.74l1 1.32a1.86 1.86 0 0 0 1.5.76h3.48a1.86 1.86 0 0 0 1.86-1.73 1.86 1.86 0 0 1-1.86 2h-3.48a1.86 1.86 0 0 1-1.5-.76l-1-1.32a1.57 1.57 0 0 1-.3-1.07 1.57 1.57 0 0 0 .3.8zM595.22 296.72h3.48a1.86 1.86 0 0 0 1.5-.76l.85-1.16a2 2 0 0 0 .37-1 2 2 0 0 1-.37 1.29l-.83 1.15a1.86 1.86 0 0 1-1.5.76h-3.5a1.86 1.86 0 0 1-1.86-2 1.86 1.86 0 0 0 1.86 1.72z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.05
  }, React.createElement("path", {
    d: "M594.22 222.64s2.47-3-.64-8.06c-.83-1.34.21-2 2.17-2.31-.34.37-.36.85 0 1.48 3.12 5 .64 8.06.64 8.06-4.12 3.67-7.06 25.11-7.06 25.11s5.5-.64 6.41.18 5.41 2.11 7.7.92 6.32-.73 7-.92c.43-.12 3.45.87 5.65.9-.94 2-7.21-.25-7.85-.07s-4.67-.27-7 .92-6.78-.09-7.7-.92-6.41-.18-6.41-.18 3-21.44 7.09-25.11zM619.98 245.59l.11.51a5.9 5.9 0 0 0-1 0 3.2 3.2 0 0 1 .89-.51z"
  })), React.createElement("path", {
    d: "M602.59 203.77s12.92-.18 15.3.46 1 14 1 14-3 1.28-4.49 0a4.17 4.17 0 0 0-4.21-1c-1 .46-4.86.27-5.5-.18s-3.57-2.29-4.49-1.19-4.86 2.11-5.68 1.92-5.41-.46-6 1c0 0-.73-12.19.46-13.47s13.61-1.54 13.61-1.54z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M602.59 203.31s12.92-.18 15.3.46 1 14 1 14-3 1.28-4.49 0a4.17 4.17 0 0 0-4.21-1c-1 .46-4.86.27-5.5-.18s-3.57-2.29-4.49-1.19-4.86 2.11-5.68 1.92-5.41-.46-6 1c0 0-.73-12.19.46-13.47s13.61-1.54 13.61-1.54z",
    fill: "#ff808e"
  }), React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M472.4 414h234.93v234.93H472.4z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M703.87 645.48H475.86V417.47h228.01z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M693.49 583.15H486.25v-155.3h207.24z"
  }), React.createElement("ellipse", {
    cx: 639.56,
    cy: 563.65,
    rx: 36.11,
    ry: 5.5,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 523.55,
    cy: 449.94,
    r: 8.54,
    fill: "#ffdf9c"
  }), React.createElement("path", {
    d: "M656.16 529.7s-.89 1.16.41 2.91 2.37 3.23 1.93 4.32c0 0-2-3.25-3.55-3.3s-.54-1.97 1.21-3.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M656.16 529.7a1.44 1.44 0 0 0-.18.36c-1.55 1.83-2.38 3.53-.89 3.57s3.06 2.53 3.46 3.16v.14s-2-3.25-3.55-3.3-.59-1.97 1.16-3.93z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M654.51 531.18c0 .41 0 .74.1.74s.1-.33.1-.74-.06-.22-.11-.22-.09-.19-.09.22z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M653.94 531.67c.36.2.67.31.7.26s-.24-.25-.6-.44-.22-.05-.24 0-.22-.02.14.18z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M660.85 529.7s.89 1.16-.41 2.91-2.37 3.23-1.93 4.32c0 0 2-3.25 3.55-3.3s.54-1.97-1.21-3.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M660.85 529.7a1.44 1.44 0 0 1 .18.36c1.55 1.83 2.38 3.53.89 3.57s-3.06 2.53-3.46 3.16v.14s2-3.25 3.55-3.3.59-1.97-1.16-3.93z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M662.5 531.18c0 .41 0 .74-.1.74s-.1-.33-.1-.74.06-.22.11-.22.09-.19.09.22z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M663.06 531.67c-.36.2-.67.31-.7.26s.24-.25.6-.44.22-.05.24 0 .22-.02-.14.18z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M662.22 536.79s-2.48-.08-3.23-.61-3.82-1.17-4-.31-3.73 4.25-.93 4.27 6.51-.44 7.26-.89.9-2.46.9-2.46z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M654 539.84c2.8 0 6.51-.44 7.26-.89.57-.35.79-1.59.87-2.16h.09s-.16 2-.9 2.46-4.45.91-7.26.89c-.81 0-1.09-.29-1.07-.72.1.25.41.41 1.01.42z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#e2e7f0",
    d: "M573.06 461.24h33.95v11.45h-33.95z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M604.6 472.22h-8.63v-10.54h8.63z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M602.77 468.9h-5.06v-4.07h5.06z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M594.14 472.22h-8.63v-10.54h8.63z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M592.32 468.9h-5.06v-4.07h5.06z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M583.69 472.22h-8.63v-10.54h8.63z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M581.85 468.9h-5.06v-4.07h5.06z"
  }), React.createElement("path", {
    d: "M573.06 461.24v.85h33.95v-.85z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M574.68 454.63l4.52-3.48h21.94l4.17 3.46a12.08 12.08 0 0 0 7.54 1s-.16 6-6 6h-34s-4.88.22-5.59-6a13.64 13.64 0 0 0 7.42-.98z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#e2e7f0",
    d: "M565.41 484.63h47.97v16.19h-47.97z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M609.98 498.83h-12.2v-14.9h12.2z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M607.4 494.13h-7.16v-5.75h7.16z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M595.2 498.83H583v-14.9h12.2z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M592.62 494.13h-7.16v-5.75h7.16z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M580.42 498.83h-12.2v-14.9h12.2z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M577.84 494.13h-7.16v-5.75h7.16z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M617.96 539.06h-58.3v-20.41h58.3z"
  }), React.createElement("path", {
    fill: "#e2e7f0",
    d: "M617.96 539.06h-58.3v-20.41h58.3z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M611.86 538.59h-17.59v-19.94h17.59z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M608.34 538.59h-10.56v-19.94h10.56z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M605.99 535.78h-5.28v-14.19h5.28zM583.59 538.59H566v-19.94h17.59z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M580.07 538.59h-10.56v-19.94h10.56z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M577.73 535.78h-5.28v-14.19h5.28z"
  }), React.createElement("path", {
    d: "M626.29 538.12v-19.51c11.28-.81 11.61-12.74 11.61-12.74a25.85 25.85 0 0 1-16.12-2.23l-8.91-7.39H566l-9.68 7.46a29.15 29.15 0 0 1-15.89 2.16c1.39 12.08 10.18 12.76 11.73 12.79v19.47m0 0h74.13m-4.11 0h-65.96m0 0v-19.48h66v19.47",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M565.41 484.63h47.97v2.08h-47.97z"
  }), React.createElement("path", {
    d: "M566.63 475.67l6.5-5.28h33.9l6 5.23a18.29 18.29 0 0 0 11.4 1.58s-.25 9-9.09 9h-51.49s-7.39.33-8.47-9a20.62 20.62 0 0 0 11.25-1.53z",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M618.02 519.19h-58.3v-.59h58.3zM621.77 503.7h-65.45a492.69 492.69 0 0 0 65.45 0zM613.44 475.54h-46.8a252.23 252.23 0 0 0 46.8 0zM605.35 454.54h-30.73a109.12 109.12 0 0 0 30.73 0z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M665.95 542.35H502.82v-4.4h163.13z"
  }), React.createElement("path", {
    d: "M750.38 540.06a12.34 12.34 0 0 0 2 2.17c1.86 1.43 4.43 1.34 6.78 1.51a9.68 9.68 0 0 0 2.6 0 3.3 3.3 0 0 0 .95-.35 2.35 2.35 0 0 0 1.3-1.27c.42-1.15-.35-2.39-1.25-3.22a9.39 9.39 0 0 1-2.51-2.65c-.68-1.49-.13-3.38-1-4.78a1.47 1.47 0 0 0-.7-.64 3.13 3.13 0 0 0-1.2 0 4.29 4.29 0 0 1-3.63-2.57c-.73-1.38-1-2.95-1.7-4.36a7.37 7.37 0 0 0-3.64-3.71 26 26 0 0 0-3-.85 35.23 35.23 0 0 0-3.38-1.05 4.22 4.22 0 0 0-2.79.35 2.73 2.73 0 0 0-.79.52c-.8.77-1 2-1.8 2.78a3 3 0 0 0-.8 1c-.21.58.34.83.91 1a5.45 5.45 0 0 0-.68 2.65 5.5 5.5 0 0 0 4.87 5.46l.15.26a15.48 15.48 0 0 1 .9 1.84 3.68 3.68 0 0 0-.27 1.73 2 2 0 0 0 .83 1.23 8.36 8.36 0 0 0-2 1.66 4.91 4.91 0 0 1-2.13 1.63l-.26.08a3 3 0 0 0-1.76 3.74c.63 3-.76 7.58-.76 7.58l-.51 3.79v.13l-4.56 3s-7.24 2.4-4.82 5.18 6.22-3 6.22-3l2.81-1.29-.07.66c-.37 3.48-1 8-1.73 10.11l-.93 3.49-1.65 7.71s-.89 1.64 0 5.05l-2.92 9.47v.13a32.16 32.16 0 0 1-1.88 5.21l-.15.26-.08.12v.05a.72.72 0 0 0-.88.15 2.44 2.44 0 0 0-.34.45c-.51.88-4.32 1.64-5.08 1.39s-3.43-.51-2.79 1.39 12.06 4.67 12.06 4.67 1.27-1.77 1.14-3a14.44 14.44 0 0 1 0-2.53 4.7 4.7 0 0 1-.53.41V604.59l.08-.33V603.56l.05-.18v-.19l.05-.16.06-.18v-.24l.06-.16.06-.15V602.07l.07-.15.05-.11v-.06l.05-.1.07-.13.05-.09.06-.09.08-.11.06-.07.08-.08c1-.88 4.32-9.73 4.32-9.73l1-6.19s2.54-6.78 5.08-9.65l4.57 7.63a44.39 44.39 0 0 0 4.06 4.93s3.3 6.57 5.46 9.22a7.35 7.35 0 0 1 1.38 4.84c0 .3 0 .58-.05.83a3.18 3.18 0 0 1-1.7 2c-1.9.76-4.57 2-3.68 3.16s3.93 2.15 6.6 1.26a47.31 47.31 0 0 0 6.47-3L762 601a8.65 8.65 0 0 1-.45.81l-.16-.21c-1-1.53-2.69-6.67-2.69-6.67-1.65-7.71-6-11.37-6-11.37l-2-4-2.13-8.28a13.1 13.1 0 0 0 1.27-.62.93.93 0 0 0 1.49.05c2.54-2.27-.51-7.83-.51-7.83s-.13-2.78 0-4.8-1.14-6.19-1.14-6.19l-.84-5.23 1.09-3.11a16.22 16.22 0 0 0 .45-3.49zm-2.81 17.24a10.82 10.82 0 0 1 .58 3.56 6.86 6.86 0 0 0-1.47-1.67s-2.53-3.92-.67-6.78c.2-.31.39-.62.59-.94a22.06 22.06 0 0 0 .97 5.83z",
    transform: "translate(-96.78 -42.46)",
    fill: "url(#prefix__f)"
  }), React.createElement("path", {
    d: "M651.73 503.54l1 6.17s1.24 4.07 1.12 6 0 4.69 0 4.69 3 5.43.5 7.65-3.22-7-3.22-7 .37-3.95-.5-6-1-6.66-1-6.66z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M651.73 503.54l1 6.17s1.24 4.07 1.12 6 0 4.69 0 4.69 3 5.43.5 7.65-3.22-7-3.22-7 .37-3.95-.5-6-1-6.66-1-6.66z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M637.22 524.74l-1.72 6.42-1.61 7.53s-.87 1.6 0 4.94l-2.85 9.25s-1.61 5.92-2.6 6 1 4.69 1 4.69l2.73-1.6s.74-3.7 1.74-4.57 4.22-9.5 4.22-9.5l1-6s3.1-8.27 5.83-10.24a10.47 10.47 0 0 0 3.6-5.18z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M648.51 526.47a10.47 10.47 0 0 1-3.6 5.18c-2.73 2-5.83 10.24-5.83 10.24l-1 6s-3.22 8.64-4.22 9.5c-.73.63-1.32 2.8-1.59 3.9-.1.4-.15.66-.15.66l-2.73 1.6s-2-4.57-1-4.69c.15 0 .32-.18.5-.43 1-1.38 2.11-5.61 2.11-5.61l2.85-9.25c-.87-3.33 0-4.94 0-4.94l1.61-7.53 1.76-6.36z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M664.38 558.54l-1 2.34-4.46-.49a10.25 10.25 0 0 0 .23-1.94 7.18 7.18 0 0 0-1.34-4.73c-2.11-2.59-5.33-9-5.33-9a43.36 43.36 0 0 1-4-4.81l-6.18-10.37.19-.93-1.67-1.54h10.4l2.48 9.62 2 3.95s4.22 3.58 5.83 11.11c0 0 1.61 5 2.63 6.51a1.8 1.8 0 0 0 .22.28z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M632.29 561.35c-.1.4-.15.66-.15.66l-2.73 1.6s-2-4.57-1-4.69c.15 0 .32-.18.5-.43a.69.69 0 0 1 .32.77 1.91 1.91 0 0 1-.2.53c-.37.62 1.24 1.6 1.24 1.6.56.7 1.44.33 2.02-.04z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M629.12 559.54a.72.72 0 0 0-1.23-.65 2.39 2.39 0 0 0-.33.44c-.5.86-4.22 1.6-5 1.36s-3.35-.49-2.73 1.36 11.82 4.49 11.82 4.49a5.76 5.76 0 0 0 1.12-3 14.1 14.1 0 0 1 0-2.47s-1.74 1.6-2.6.49c0 0-1.61-1-1.24-1.6a1.91 1.91 0 0 0 .19-.42z",
    fill: "#dce6f2"
  }), React.createElement("path", {
    d: "M664.38 558.54l-1 2.34-4.46-.49a10.25 10.25 0 0 0 .23-1.94.61.61 0 0 1 1-.14c.23.25.46.51.64.72.5.62 2.11.25 2.11.25.42.14.91-.46 1.27-1a1.8 1.8 0 0 0 .21.26z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M660.27 558.54a.61.61 0 0 0-1 .26 3.39 3.39 0 0 1-1.8 2.44c-1.86.74-4.46 2-3.6 3.08s3.84 2.1 6.45 1.23a46.2 46.2 0 0 0 6.32-3l-1.86-4.94s-1 2.1-1.74 1.85c0 0-1.61.37-2.11-.25-.19-.13-.43-.39-.66-.67z",
    fill: "#dce6f2"
  }), React.createElement("path", {
    d: "M643.43 489.21s3 4.07 2.23 6.91 6-1.85 6-1.85a9.83 9.83 0 0 1-2.85-8.14z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M653.22 527.83c-5 3-10.91 1.73-10.91 1.73l.12-.86h-.26c-4.74.42-5.82-1-5.82-1a55.63 55.63 0 0 0 1.68-9.87l.14-1.39c.1-1 .17-1.82.22-2.39s.06-.78.06-.78l.5-3.7s1.36-4.44.74-7.4a3 3 0 0 1 1.73-3.63l.25-.07a4.79 4.79 0 0 0 2.08-1.59 8.36 8.36 0 0 1 3.48-2.36c.62-.23 1.15-.47 1.15-.47.87-1 3.22-.37 3.22-.37 2.85 1.85 1.36 7.9 1.36 7.9l-1.19 3.37a25 25 0 0 1-2.69 5.3c-1.82 2.8.65 6.63.65 6.63 3.86 3.05 3.49 10.95 3.49 10.95z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M642.62 522.09l-.44 6.63c-4.74.42-5.82-1-5.82-1a55.63 55.63 0 0 0 1.68-9.87l.14-1.39z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M650.49 504.76s-2.23 4.2-3 6-.74 1.23-1.12 1.85a37.68 37.68 0 0 1-4.34 3.33l-4 1.85c.17-1.59.29-3 .36-3.78l3.83-2.47s2.6-1.6 2.73-3.7a25.39 25.39 0 0 1 1.74-5.92s3.22-3.45 4.59-1.85-.79 4.69-.79 4.69z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M646.65 501.3a25.39 25.39 0 0 0-1.74 5.92c-.12 2.1-2.73 3.7-2.73 3.7l-8.18 5.43s-7.07 2.34-4.71 5.06 6.07-3 6.07-3l6.69-3.08a37.68 37.68 0 0 0 4.34-3.33c.37-.62.37 0 1.12-1.85s3-6 3-6 2.11-3.08.74-4.69-4.6 1.84-4.6 1.84z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M645.66 502.91a30.79 30.79 0 0 0 3-2.47.7.7 0 0 1 .87-.1 3.92 3.92 0 0 0 1.84.3c.54 0 1.07 0 1 .29-.12.62.37-3.21.37-3.21l-2.11-.74-2.73 1.48z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M645.66 502.66a30.79 30.79 0 0 0 3-2.47.7.7 0 0 1 .87-.1 3.92 3.92 0 0 0 1.84.3c.54 0 1.07 0 1 .29-.12.62.37-3.21.37-3.21l-2.11-.74-2.73 1.48z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M639.82 502.91a3.05 3.05 0 0 0 2.8-.19M647.95 486.43c-.09-.74.82.79.93-.06l-5.33 3.08s.3.42.69 1.08a5.47 5.47 0 0 0 .61 0c1.61.01 2.12-2.99 3.1-4.1z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 644.73,
    cy: 484.95,
    rx: 5.39,
    ry: 5.37,
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M642.31 485.05a2.74 2.74 0 0 0 .19 1c.23.42.71.61 1.12.86a4.59 4.59 0 0 1 1.61 5.14 4.53 4.53 0 0 0-.36 2c.21 1.15 1.53 1.75 2.7 1.85a12.55 12.55 0 0 1 3.5.34c1.84.71 2.65 2.86 4.22 4.06 1.82 1.4 4.33 1.31 6.62 1.47a9.46 9.46 0 0 0 2.54 0 2.56 2.56 0 0 0 1.95-1.46c.42-1.12-.34-2.33-1.22-3.15a9.18 9.18 0 0 1-2.45-2.58c-.67-1.46-.13-3.3-1-4.67a1.44 1.44 0 0 0-.68-.62 3.05 3.05 0 0 0-1.18 0 4.19 4.19 0 0 1-3.55-2.51c-.71-1.35-1-2.88-1.66-4.26a7.2 7.2 0 0 0-3.56-3.62 25.43 25.43 0 0 0-2.93-.83 34.42 34.42 0 0 0-3.3-1 3.72 3.72 0 0 0-3.25.73c-.78.75-1 1.93-1.76 2.72a3 3 0 0 0-.78.93c-.32.91 1.24 1 1.76 1.36a3.41 3.41 0 0 1 1.47 2.24z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M642.56 484.92a2.74 2.74 0 0 0 .19 1c.23.42.71.61 1.12.86a4.59 4.59 0 0 1 1.61 5.14 4.53 4.53 0 0 0-.36 2c.21 1.15 1.53 1.75 2.7 1.85a12.55 12.55 0 0 1 3.5.34c1.84.71 2.65 2.86 4.22 4.06 1.82 1.4 4.33 1.31 6.62 1.47a9.46 9.46 0 0 0 2.54 0 2.56 2.56 0 0 0 1.95-1.46c.42-1.12-.34-2.33-1.22-3.15a9.18 9.18 0 0 1-2.45-2.58c-.67-1.46-.13-3.3-1-4.67a1.44 1.44 0 0 0-.68-.62 3.05 3.05 0 0 0-1.18 0 4.19 4.19 0 0 1-3.55-2.51c-.71-1.35-1-2.88-1.66-4.26a7.2 7.2 0 0 0-3.56-3.62 25.43 25.43 0 0 0-2.93-.83 34.42 34.42 0 0 0-3.3-1 3.72 3.72 0 0 0-3.25.73c-.78.75-1 1.93-1.76 2.72a3 3 0 0 0-.78.93c-.32.91 1.24 1 1.76 1.36a3.41 3.41 0 0 1 1.47 2.24z",
    fill: "#2d283d"
  }), React.createElement("path", {
    transform: "rotate(-82.34 423.605 431.34)",
    fill: "url(#prefix__g)",
    d: "M378.81 279.77h234.93V514.7H378.81z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M497.284 482.963L271.31 452.571 301.7 226.595l225.976 30.393z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M495.303 419.813l-205.39-27.624 20.7-153.914 205.39 27.624z"
  }), React.createElement("path", {
    d: "M335.78 328.75s-4 5.8-1.88 9.56-1.94 12.66-1.94 12.66",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M335.1 326.68a3.69 3.69 0 0 0 .59 2.29 3.15 3.15 0 0 0 .58-4.35 3.69 3.69 0 0 0-1.17 2.06z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M334.14 328.54s2.34 6.66-.71 9.72-1.47 12.73-1.47 12.73",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M335.34 326.71a3.69 3.69 0 0 1-1.17 2.06 3.15 3.15 0 0 1 .58-4.35 3.69 3.69 0 0 1 .59 2.29z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M335.34 326.71a3.69 3.69 0 0 1-1.17 2.06 3.15 3.15 0 0 1 .58-4.35 3.69 3.69 0 0 1 .59 2.29z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M332.84 328.35s-4 5.8-1.88 9.56-1.94 12.63-1.94 12.63",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M332.16 326.29a3.69 3.69 0 0 0 .59 2.29 3.15 3.15 0 0 0 .58-4.35 3.69 3.69 0 0 0-1.17 2.06zM331.99 331.34a3.69 3.69 0 0 0 2 1.24 3.15 3.15 0 0 0-2.59-3.54 3.69 3.69 0 0 0 .59 2.3zM331.33 335.63a3.69 3.69 0 0 0 2 1.24 3.15 3.15 0 0 0-2.59-3.54 3.69 3.69 0 0 0 .59 2.3zM335.52 338.6a3.69 3.69 0 0 0-1.06 2.12 3.15 3.15 0 0 0 3.29-2.9 3.69 3.69 0 0 0-2.23.78zM336.03 329.34a3.69 3.69 0 0 0-1.59 1.76 3.15 3.15 0 0 0 3.95-1.92 3.69 3.69 0 0 0-2.36.16z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M336.03 329.34a3.69 3.69 0 0 0-1.59 1.76 3.15 3.15 0 0 0 3.95-1.92 3.69 3.69 0 0 0-2.36.16z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M331.22 328.13s2.34 6.66-.71 9.72-1.49 12.69-1.49 12.69",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M332.4 326.32a3.69 3.69 0 0 1-1.17 2.06 3.15 3.15 0 0 1 .58-4.35 3.69 3.69 0 0 1 .59 2.29z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M332.4 326.32a3.69 3.69 0 0 1-1.17 2.06 3.15 3.15 0 0 1 .58-4.35 3.69 3.69 0 0 1 .59 2.29z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M331.46 331.37a3.69 3.69 0 0 1 .61 2.29 3.15 3.15 0 1 1-.61-2.29z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M331.46 331.37a3.69 3.69 0 0 1 .61 2.29 3.15 3.15 0 1 1-.61-2.29z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M329.01 337.1a3.69 3.69 0 0 1 .61 2.29 3.15 3.15 0 1 1-.61-2.29z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M331.62 336.11s-1.51-3.27-4.18-3.69M333.35 334.54s2.32-2.75 5-2.46M333.02 338.83s-1.51-3.27-4.18-3.69",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("circle", {
    cx: 424.31,
    cy: 374.87,
    r: 0.5,
    transform: "rotate(-82.34 351.648 408.974)",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 435.09,
    cy: 374.51,
    r: 0.5,
    transform: "rotate(-82.34 362.416 408.614)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M331.48 339.63s2.32-2.75 5-2.46",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("circle", {
    cx: 433.22,
    cy: 379.64,
    r: 0.5,
    transform: "rotate(-82.34 360.552 413.745)",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 425.58,
    cy: 377.61,
    r: 0.5,
    transform: "rotate(-82.34 352.918 411.71)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M319.92 345.67s4.73-.3 6.12-1.36 7.21-2.47 7.61-.85 7.38 7.87 2 8.09-12.44-.42-13.89-1.24-1.84-4.64-1.84-4.64z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M335.77 350.97c-5.34.22-12.44-.42-13.89-1.24-1.11-.62-1.62-3-1.8-4.07h-.16s.43 3.81 1.88 4.63 8.55 1.46 13.89 1.24c1.54-.06 2.06-.63 2-1.44-.2.51-.78.83-1.92.88z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M472.91 373.01s-1.79 1.78 0 5.08 3.31 6.08 2.32 7.85c0 0-2.6-6-5.32-6.47s-.45-3.51 3-6.46z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M472.91 373.01a2.48 2.48 0 0 0-.39.58c-3.08 2.77-4.89 5.5-2.34 5.91 2.37.39 4.66 5 5.2 6.2a2.33 2.33 0 0 1-.11.23s-2.6-6-5.32-6.47-.49-3.5 2.96-6.45z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M469.74 375.16c-.09.7-.09 1.28 0 1.29s.25-.54.35-1.24 0-.38-.15-.4-.1-.35-.2.35z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M468.66 375.87c.57.42 1.08.69 1.14.61s-.36-.48-.93-.9-.36-.14-.42-.06-.36-.07.21.35z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M480.94 374.09s1.25 2.19-1.37 4.89-4.8 5-4.31 7c0 0 4.1-5.12 6.84-4.83s1.39-3.31-1.16-7.06z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M480.94 374.09a2.48 2.48 0 0 1 .23.67c2.24 3.49 3.27 6.59.7 6.32-2.39-.25-5.82 3.62-6.65 4.61a2.33 2.33 0 0 0 0 .26s4.1-5.12 6.84-4.83 1.43-3.28-1.12-7.03z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M483.42 377c-.09.7-.25 1.26-.35 1.24s-.1-.59 0-1.29.15-.36.24-.34.21-.31.11.39z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M484.28 377.97c-.66.25-1.22.38-1.26.29s.47-.37 1.13-.62.38 0 .42.05.37.02-.29.28z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M481.65 386.54s-4.23-.7-5.39-1.79-6.27-2.88-6.78-1.46-7.36 6.42-2.57 7.1 11.25.75 12.63.15 2.11-4 2.11-4z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M466.89 389.87c4.79.68 11.25.75 12.63.15 1.05-.46 1.73-2.54 2-3.5h.14s-.73 3.39-2.11 4-7.84.54-12.63-.15c-1.38-.2-1.8-.75-1.67-1.48.12.49.61.83 1.64.98z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M435.39 403.92a22.12 22.12 0 1 0 33.33-15.78l-.24-.14 5.35-10.25 22 29.73a4.72 4.72 0 0 0-.69 3.2c-.35.12-.7.26-1 .41a6.89 6.89 0 0 1-3.48.76s-2.91 1.86 2.07 2.91l.28.06-.41 3 11.18 1.5.34-2.5a55.21 55.21 0 0 0 10.6 1.39 22 22 0 1 0 10-19.11l-.26.18-2.14-2.9 2.72-1.7-4.5-3.89a5.12 5.12 0 0 1-.56.86l-.21-.15c-.56-.41-1.39-1-2.25-1.71l-.1-.08 1-7.48v-.3a27.39 27.39 0 0 0 3.29.37c4.83.2 5.84-2.82 4.29-4.83-1.23-1.6-6.65-1.48-8.8-1.36a14.76 14.76 0 0 1-1.65 0h-.26c1.66-2.45 4-5.68 6.79-10.52 3.32-5.7 3.38-9.4 2.86-11.49 0-.67-.44-7.63-3-10.11s-4.55-5.68-7.13-14.66c-1.71-6-5.77-7.52-8.31-7.9.61-.35.94-1 1.51-1.41 1.1-.78 3-.56 3.57-1.74 1.19-2.49-2.87-2.2-4.08-2.52s-1-1.08-1-2a7.8 7.8 0 0 0-1-3.42 2.51 2.51 0 0 0-.72-.84 2.77 2.77 0 0 0-1.34-.37c-1.61-.12-3.26.19-4.83-.18-.6-.14-1.18-.39-1.79-.5a5.07 5.07 0 0 0-5 2.43 8.66 8.66 0 0 0-.93 5.49 4.05 4.05 0 0 0 1 2.55 9.57 9.57 0 0 1 1 .88 4.7 4.7 0 0 1 .46.91 6.38 6.38 0 0 0 0 .8c-.39.19-.76.41-1.12.63a14.1 14.1 0 0 0-6.55 11.9c0 3.82-.49 8.58-.49 8.58A6.2 6.2 0 0 0 487 344l-.17 3.21a12.45 12.45 0 0 1-.31 2.11V351.94c0 .24.09.5.15.77a19.33 19.33 0 0 1 .32 6.78l-.55 4.12a42.15 42.15 0 0 0-8.7-.19l-.29-.14s-3.64 0-2.69 3.09l.55.24-.12.26-9.46 19.74a22.32 22.32 0 0 0-5.48-1.46 22 22 0 0 0-24.86 18.77zm11.78 15.93l9.1-10.94a2.41 2.41 0 0 0 .47.19L454 423a16.72 16.72 0 0 1-6.83-3.15zm14.83 2.87l-2.88-14.22 10.37 9.77a16.73 16.73 0 0 1-7.49 4.45zm-3.09-32.38l-1.36 13.37-.22.45a2.41 2.41 0 0 0-1.12.43l-4.62-13.3a16.74 16.74 0 0 1 7.28-.94zm.37 0h.35a16.91 16.91 0 0 1 3.82 1L458 402.72zm11.27 6.24l1.16 1.65a16.55 16.55 0 0 1 1.25 2.48l-13 5.1a2.38 2.38 0 0 0-.36-.72l6.5-12.46.24.15a16.74 16.74 0 0 1 4.17 3.85zm3.48 12l-14-1.64v-.09a2.36 2.36 0 0 0 0-.62l12.97-5.12a16.31 16.31 0 0 1 1 7.47zm-19-2.1a2.35 2.35 0 0 0 .19 1.28l-13 5.93a16.41 16.41 0 0 1 0-13.9l12.81 6.44a2.38 2.38 0 0 0-.03.26zm-3.79-15.06l4.66 13.42a4.94 4.94 0 0 0-.7 1l-12.77-6.42a16.62 16.62 0 0 1 8.78-7.99zm27.58-23.23l5.3 2.36a5.57 5.57 0 0 0 .52.88 2 2 0 0 1 0-.63l8.89 4-.62 3.33-15.56-7.19 1.29-2.47zm47.79 62.25l9-10.87a2.43 2.43 0 0 0 .53.14l-2.78 13.85a16.72 16.72 0 0 1-6.78-3.1zm14.79 2.87l-2.88-14.22 10.37 9.77a16.73 16.73 0 0 1-7.52 4.47zm-2.16-15.8a2.34 2.34 0 0 0-.05-.61l13.31-5.21a16.31 16.31 0 0 1 .95 7.47zm-.95-16.51l-1.43 14a2.42 2.42 0 0 0-.88 0l-.76-1-4.22-12.1a16.73 16.73 0 0 1 7.29-.9zm-5 14.9l-11.5-5.78a16.39 16.39 0 0 1 3-4.24zm.77.91c-2.18-.87-7.4-2.93-13-4.91l.1-.27q.23-.6.5-1.18l12.27 6.17zm4.6-15.81h.35a16.81 16.81 0 0 1 5.87 1.93l-6.65 12.53a2.41 2.41 0 0 0-1-.42zm6.54 2.15a16.74 16.74 0 0 1 4.73 4.09l1.16 1.66a16.55 16.55 0 0 1 1.25 2.48l-13.28 5.2a2.4 2.4 0 0 0-.54-.82zm-10.83 15.34l-12.72 5.82a16.33 16.33 0 0 1-1.5-5.83c6.03.16 11.78.06 14.22.01zm-18.49-8.39l-1.26-.4v-.3l.55-4.11 5.65-4.21.5.6a21.7 21.7 0 0 0-5.39 8.14zm0-9.74l.12-.08-.12.09zm-3.52-3.16a12.4 12.4 0 0 1-2.94 3.72l.94-6.49a8.84 8.84 0 0 0 .93-2.3l.21.17.12.1.19.16.13.11.16.13.13.11.14.12.12.11.11.1.25.22zm-16.93-32.45l-2.59-.37c1.22-.94 2.26-1.66 2.26-1.66l.81-.54zm-1.27 6.85l-6.42-3.19a10 10 0 0 1 1.32-.31l.06-.13c2.1.27 4.08.48 5.6.63zm-2.82-11.76a16.42 16.42 0 0 1 1.13-4.42l.06-.1v-.11l.05-.16v-.17c0-.14.07-.29.1-.46 0-.17.07-.36.1-.57v-.31c0-.22.06-.46.1-.7 0-.24.06-.5.09-.76q0-.4.08-.81v-3.43c.1-1.44.17-2.85.23-4v-.39c2.94 1.64 4.22 4.62 4.76 7.35a45.77 45.77 0 0 0-3.93 6s-.91 1.2-2.78 3.05zm19.49 48.73c-.85-.23-1.66-.44-2.43-.63l.47-3.21 2.71-1.69-.7 5.23zm3.65-27.15l-.68 5a24.65 24.65 0 0 0-1.88-1.75h.13l.37-2.77a5.65 5.65 0 0 1 .28-1.35c.59.19 1.19.36 1.81.53zm13.33 22.05a16.73 16.73 0 0 1 2.83-1.43l3.81 11-6.9-9.37zm21.34 25.12l-10.38-9.78a2.35 2.35 0 0 0 .4-.9l14.21 1.66v.08a16.33 16.33 0 0 1-4.24 8.94zm-15.41 5.07l2.79-13.88a2.41 2.41 0 0 0 1.64-.4l2.84 14a16.8 16.8 0 0 1-6.41.37zm-11.92-9l12.77-5.84a2.41 2.41 0 0 0 .69.62l-9 10.81a16.71 16.71 0 0 1-4.47-5.61zM475.3 374.9l.47-.91 26.9 13.35.36 8.77a20.7 20.7 0 0 0 .46 3.68 13.43 13.43 0 0 1-.62 6.37 4.83 4.83 0 0 0-2.1-.81h-.3a4.86 4.86 0 0 0-1.34 0zm-5.57 43.1l-10.38-9.78.13-.2a2.35 2.35 0 0 0 .38-.69L474 409a16.33 16.33 0 0 1-4.27 9zm-15.41 5l2.79-13.88a2.41 2.41 0 0 0 1.64-.4l2.84 14a16.8 16.8 0 0 1-6.41.37zm-11.93-9l13-5.94a2.41 2.41 0 0 0 .57.61l-9.07 10.91a16.71 16.71 0 0 1-4.5-5.58z",
    transform: "translate(-96.78 -42.46)",
    fill: "url(#prefix__h)"
  }), React.createElement("path", {
    d: "M350.71 376.85l10.8-13.11-.57.23-16.33 7.57.12-16.83 16.91 8.57v-.19l-1-1-5.61-16.39 8.43-.37v-.27h.36v.22l5.67-.25 1.27 1.83.17-.32 5.93 9.15 4 5.79-1.16 3.93-16.48-1.87v-.36l16.14 1.88 1-3.46-2.93-4.23-15.07 6 .78.74h.07l12.06 11.48-9.05 4.88-3.21-16.1-1.09-.55-3.53 17.61zm.55-.09l6.84 4.13 3.29-16.43zm12.2-12l3 15.13 8.3-4.36zm-18.38-9.5l-.11 15.66 15.82-7.33.41-.16zm25.5-8l-1.26-1.83-5.52.24-1.75 17.22.07.07.55-.67zm6 8.66l-5.75-8.32-7.84 14.94-.29.35 14.6-5.79zm-21-9.89l5.42 15.84.74.7 1.72-16.89zM428.02 387.17l10.8-13.11-.57.23-16.34 7.57.12-16.83 16.91 8.57v-.19l-1-1-5.61-16.39 8.43-.37v-.27h.36v.22l5.67-.25 1.27 1.83.17-.32 5.92 9.14 4 5.79-1.16 3.93-16.45-1.91v-.36l16.14 1.88 1-3.46-2.93-4.23-15.07 6 .78.74h.07l12.06 11.48-9.19 4.82-3.21-16.1-1.09-.55-3.53 17.61zm.55-.09l6.84 4.13 3.29-16.43zm12.2-12l3 15.13 8.3-4.36zm-18.38-9.5l-.11 15.66 15.82-7.33.41-.16zm25.5-8l-1.26-1.83-5.52.24-1.75 17.22.07.07.55-.67zm6 8.66l-5.75-8.32-7.83 14.88-.29.35 14.6-5.79zm-21-9.89l5.42 15.84.74.7 1.72-16.89z",
    fill: "#535461"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M426.608 355.242l-8.774 6.602-2.092-2.78 8.773-6.603z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M426.608 355.242l-8.774 6.602-2.092-2.78 8.773-6.603z"
  }), React.createElement("path", {
    d: "M423.16 348.54a45.79 45.79 0 0 1-5.71-4.74 23.86 23.86 0 0 0-3-2.91l-5.23-4.17-11.67-2.49-.81 1.92s-1.3 2.78 7.43 6.54 12.73 8.36 12.73 8.36 5.55 2.77 6.26-2.51z",
    fill: "#db8b8b"
  }), React.createElement("path", {
    d: "M416.49 350.59c.29.29.43.45.43.45s5.54 2.78 6.24-2.48l-.68-.5a5.06 5.06 0 0 1-4.6 1.82l-.61-.08z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M396.8 337.18c.36 1.14 1.86 3.13 7.4 5.51a39.72 39.72 0 0 1 12.3 7.91c.29.29.43.45.43.45s5.54 2.78 6.24-2.48l-.68-.5a38.62 38.62 0 0 1-5-4.25 23.8 23.8 0 0 0-3-2.91l-5.27-4.19-2.08-.44-9.59-2-.81 1.92a1.52 1.52 0 0 0 .06.98z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M423.22 347.37l4.38 3.82-15.66 9.89s-1.9-1.54-.61-2.85c0 0 4-2.6 4.81-6.92l1.28-1.3.62.08a5.06 5.06 0 0 0 5.19-2.72z",
    fill: "#abb1d1"
  }), React.createElement("path", {
    d: "M396.8 337.18c3.09-1 10.2-.21 10.2-.21l.17-.7-9.59-2-.81 1.92a1.52 1.52 0 0 0 .03.99z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M407.04 336.61s-8.55-1-11 .56l4-21.8 11.79 1.59z",
    fill: "#abb1d1"
  }), React.createElement("path", {
    d: "M407.05 336.54s-8.55-1-11 .56l4-21.8 11.79 1.59z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M340.41 360.38a21.53 21.53 0 1 0 32.47-15.57 21.15 21.15 0 0 0-2.67-1.37 21.55 21.55 0 0 0-29.8 16.93zm5.31.64a16.27 16.27 0 0 1 22.26-12.89 16.06 16.06 0 0 1 2.51 1.29 16.26 16.26 0 1 1-24.78 11.59zM402 322.26s-21.24-3.6-22-.9 21.12 4.47 21.12 4.47a3 3 0 0 0 .88-3.57z",
    fill: "#535461"
  }), React.createElement("path", {
    d: "M402 322.26s-21.24-3.6-22-.9 21.12 4.47 21.12 4.47a3 3 0 0 0 .88-3.57z",
    opacity: 0.05
  }), React.createElement("circle", {
    cx: 408.32,
    cy: 382.96,
    fill: "none",
    stroke: "#c1272d",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M413.385 368.423l4.412-32.804 3.776.507-4.412 32.805z"
  }), React.createElement("path", {
    d: "M417.79 335.61l-.34 2.53c1.23.33 2.51.61 3.73.81l.38-2.83z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M418.44 332.93a14.23 14.23 0 0 0 1.61 0c2.1-.12 7.37-.24 8.57 1.33 1.51 2 .52 4.95-4.19 4.76s-12.53-2.42-13.89-4.38a14.64 14.64 0 0 1 7.9-1.71z",
    fill: "#535461"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M417.59 344.75l-37.97-17.67-1.72 2.87 38.78 19.4.91-4.6zM403.22 362.62l-24.81-32.01-1.91 2.11 23.46 32.12 3.26-2.22z"
  }), React.createElement("path", {
    d: "M367.99 348.13a16.06 16.06 0 0 1 2.51 1.29l2.38-4.61a21.15 21.15 0 0 0-2.67-1.37z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M361.22 361.7l1.88 1.43 19.5-37.69.87-1.69-3.09-2.33-1.18 2.49-17.98 37.79z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M379.2 323.91l3.4 1.53.87-1.69-3.09-2.33-1.18 2.49z"
  }), React.createElement("path", {
    d: "M400.38 329.87l-19-9.5s-3.54 0-2.63 3l19.23 8.65s3.05.75 2.4-2.15zM417.72 370.7a21.8 21.8 0 0 0-.19 3.36 21.74 21.74 0 1 0 .19-3.36zm5.18 3.58a16.4 16.4 0 0 1 1-6.49 16.26 16.26 0 1 1-1 6.49z",
    fill: "#535461"
  }), React.createElement("path", {
    d: "M417.72 370.7a21.8 21.8 0 0 0-.19 3.36c1.76.1 3.58.18 5.37.22a16.4 16.4 0 0 1 1-6.49c-1.67-.59-3.38-1.18-5-1.72a21.52 21.52 0 0 0-1.18 4.63zM413.89 364.54l-.52 3.86 3.77.51.44-3.27c-1.27-.38-2.51-.75-3.69-1.1z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M437.55 373.3s-29.41-12.08-32.29-9.37-6 6.43 1.46 8.92 31.25 1.69 31.25 1.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M424.36 357.84l3.39 4.07a16.28 16.28 0 0 1 2.64-2.1l-3.1-4.27a21.74 21.74 0 0 0-2.93 2.3z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M438.78 371.83l-19.59-26.87-1.47 5.42 19.6 23.48 1.46-2.03z"
  }), React.createElement("circle", {
    cx: 535.64,
    cy: 415.93,
    r: 2.34,
    transform: "rotate(-82.34 462.972 450.036)",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 535.93,
    cy: 415.97,
    r: 2.34,
    transform: "rotate(-82.34 463.26 450.076)",
    fill: "#535461"
  }), React.createElement("circle", {
    cx: 458.8,
    cy: 405.38,
    r: 2.34,
    transform: "rotate(-82.34 386.137 439.479)",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 458.61,
    cy: 405.65,
    r: 2.34,
    transform: "rotate(-82.34 385.95 439.75)",
    fill: "#535461"
  }), React.createElement("circle", {
    cx: 500.24,
    cy: 408.81,
    r: 4.69,
    transform: "rotate(-82.5 426.058 443.485)",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 499.95,
    cy: 408.77,
    r: 4.69,
    transform: "rotate(-82.34 427.284 442.871)",
    fill: "#535461"
  }), React.createElement("rect", {
    x: 496.94,
    y: 407.35,
    width: 2.49,
    height: 8.7,
    rx: 0.74,
    ry: 0.74,
    transform: "rotate(-135.55 441.15 410.23)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M390.87 298.98l-.3 5.52a12.37 12.37 0 0 1-.35 2.04 7.9 7.9 0 0 0 .15 3.4 19.19 19.19 0 0 1 .3 6.67l-.84 6.22 4.27-.16s1-8.73 1.91-10.08 1.38-14.4 1.38-14.4z",
    fill: "#db8b8b"
  }), React.createElement("path", {
    d: "M390.72 301.71l-.15 2.78a12.36 12.36 0 0 1-.35 2.05 7.9 7.9 0 0 0 .15 3.4 19.19 19.19 0 0 1 .3 6.67l-.84 6.22 4.27-.16s1-8.73 1.91-10.08c.65-1 1.07-7.78 1.27-11.69.08-1.61.12-2.72.12-2.72l-6.57.78z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M405.93 343.47l.36 9.13a20.54 20.54 0 0 0 .45 3.62c.58 2.64-.48 6.08-1.18 7.95-.31.82-.55 1.34-.55 1.34l4.37 3.17 1.6-.89.11-.73 2.34-16.11a11.51 11.51 0 0 0 1-7.8 6.2 6.2 0 0 1-.23-1.55 39.07 39.07 0 0 1 .15-4.74s-2.24-5.29-6.13-2.49a6.36 6.36 0 0 0-2.43 4 13 13 0 0 0 .14 5.1z",
    fill: "#db8b8b"
  }), React.createElement("path", {
    d: "M405.83 338.4c2.31 1.83 6.63 2.84 8.4 3.19a39.07 39.07 0 0 1 .15-4.74s-2.24-5.29-6.13-2.49a6.36 6.36 0 0 0-2.42 4.04z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M400.31 333.12a33.5 33.5 0 0 1 5 4.36c2.58 2.75 9.82 3.91 9.82 3.91l.37-2.72c.26-3.29 3.83-6.5 9.37-16.1 3.54-6.13 3.29-9.9 2.65-11.83a4.4 4.4 0 0 0-.85-1.59l-23.26 1.3-1.19 2.32-2.43 5s6.3 1.22 7.31 1.91-.37 5.49-.37 5.49c.41 5.17-6.42 7.95-6.42 7.95z",
    fill: "#abb1d1"
  }), React.createElement("path", {
    d: "M390.87 298.98l-.15 2.73c3 1.32 5.68-1.25 5.68-1.25a8.38 8.38 0 0 1 .92.45c.08-1.61.12-2.72.12-2.72zM402.22 312.77c0 .86-.1 1.39-.1 1.39s3.71 4 11.49-.3 13.93-2 13.93-2 0-.43-.08-1.12a4.4 4.4 0 0 0-.85-1.59l-23.26 1.3z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M389.37 291.54c0 3.75-.49 8.44-.49 8.44 3.73 3.83 7.56.09 7.56.09 3.8 1.59 5.19 5.28 5.65 8.41a20.27 20.27 0 0 1 .1 5.1 6 6 0 0 0 3 1.5c1.9.42 4.72.29 8.5-1.8 7.78-4.31 13.93-2 13.93-2s-.29-7.43-2.9-10-4.42-5.58-6.93-14.41-10.21-7.84-10.21-7.84-.14-1.68-7.07-1a11 11 0 0 0-4.73 1.74 13.94 13.94 0 0 0-6.41 11.77z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M397.53 281.88v.82c-.08 3.31.34 3 4.23 4.26 2.42.79 4-1.11 4.83-2.66a10.36 10.36 0 0 0 .75-1.76l-8.51-2.62s-1.05-.45-1.3 1.96z",
    fill: "#db8b8b"
  }), React.createElement("path", {
    d: "M402.09 308.54a20.27 20.27 0 0 1 .1 5.1 6 6 0 0 0 3 1.5 1.71 1.71 0 0 0 .18-.34c.58-1.58 3.69-4.12 3.69-4.12a8.34 8.34 0 0 0 2.79-4.24l4.18-8.39 1.11-.68s-3.73-3.83-7.73-1.59-3.69 8.18-3.69 8.18l-1 1.9a11.76 11.76 0 0 0-2.63 2.68z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M416.6 297.08l-5.28 9.08a8.34 8.34 0 0 1-2.79 4.24s-3.11 2.54-3.69 4.12-6.25 5.25-6.25 5.25-5.3 3.72-5.88 5.3c0 0-4.52.68-4.32 3.3 0 0-2.83-3.7.85-6.35s8.89-8.41 8.89-8.41 3.44-6.37 6.07-8l1-1.9s-.31-6 3.69-8.18 7.71 1.55 7.71 1.55z",
    fill: "#db8b8b"
  }), React.createElement("path", {
    d: "M405 365.54l4.37 3.17 1.6-.89.11-.73a11.08 11.08 0 0 1-4.45-2c-.4-.31-.78-.6-1.08-.86-.33.76-.55 1.31-.55 1.31zM409.83 288.42l-3.88 9.63s7.63 2.32 9.43 1.27a11.64 11.64 0 0 1 4.94-1s-2-9.87-3.66-11.2-6.83 1.3-6.83 1.3z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M409.88 288.05l-3.88 9.63s7.63 2.32 9.43 1.27a11.64 11.64 0 0 1 4.94-1s-2-9.87-3.66-11.2-6.83 1.3-6.83 1.3z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M397.56 281.7a6.41 6.41 0 0 0 9 2.42 10.36 10.36 0 0 0 .75-1.76l-8.51-2.62s-1-.45-1.24 1.96z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M396.88 277.63a6.41 6.41 0 0 0 12.7 1.71v-.32a6.403 6.403 0 0 0-12.73-1.39z",
    fill: "#db8b8b"
  }), React.createElement("path", {
    d: "M396.88 277.63a6.39 6.39 0 0 0 0 1.76 2.47 2.47 0 0 0 1.48.06c.71-.18 1.36-.56 2.05-.8 2-.68 4.12-.21 6.11.37a3.78 3.78 0 0 0 3 0l.09-.06a6.403 6.403 0 0 0-12.73-1.39z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M414.69 276.02c-.55 1.16-2.41.95-3.48 1.71-.56.4-.88 1.05-1.48 1.39a3.81 3.81 0 0 1-2.85-.07c-1.9-.54-4-1-5.82-.38-.66.21-1.27.55-2 .7a2.08 2.08 0 0 1-2-.42c-.38-.4-.45-1-.78-1.41a9.31 9.31 0 0 0-.95-.86 4 4 0 0 1-1-2.51 8.61 8.61 0 0 1 .91-5.4 4.93 4.93 0 0 1 4.88-2.39c.59.11 1.15.35 1.74.49 1.53.37 3.13.06 4.7.17a2.67 2.67 0 0 1 1.31.36 2.45 2.45 0 0 1 .7.82 7.71 7.71 0 0 1 1 3.36c.07.89 0 1.68 1 2s5.28-.04 4.12 2.44z",
    fill: "#472727"
  }), React.createElement("path", {
    d: "M423.91 301.11s-4.89.64-6.78 3.71-5.9 3.14-5.9 3.14",
    opacity: 0.05
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M406.896 375.462l-10.882-1.464.463-3.449 10.882 1.464z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M406.896 375.462l-10.882-1.464.463-3.449 10.882 1.464z"
  }), React.createElement("path", {
    d: "M406.58 365.4a6.81 6.81 0 0 1-1.73-1.57 16 16 0 0 1-5.1 2.77 11.05 11.05 0 0 0-2.24.76 6.67 6.67 0 0 1-3.39.75s-2.83 1.84 2 2.86 16.45 1.29 16.45 1.29l-.12-4.63a11.12 11.12 0 0 1-5.87-2.23z",
    fill: "#abb1d1"
  }), React.createElement("path", {
    d: "M202.92 318.42q0-.76.15-1.44t.26-1.59q.28-1.56.64-3 .18-.72.37-1.42a38.56 38.56 0 0 1 7.51-14.61l.6-.7q.6-.68 1.19-1.28t1.16-1.12c.38-.35.75-.67 1.11-1 .71-.6 1.38-1.09 2-1.5s.84-.57 1.19-.78a6.62 6.62 0 0 1 2.8-.93l6.17-.62 8.34-.83 30.14-11.9 1.19.43a71.7 71.7 0 0 0 2.23-7.53 6.71 6.71 0 0 1-2.38-1.77 5.52 5.52 0 0 1-1.64-2.14c-.76-1.78.69-5.58.4-7.76-.48-3.49-2.26-6.86-3.71-10-3.1-6.79-5.36-14.15-5-21.6s3.71-15 9.9-19.18c3.2-2.15 7-3.31 10.29-5.27 2.59-1.53 4.87-3.53 7.34-5.25a41.58 41.58 0 0 1 41.53-3c6.26 3.14 11.6 7.82 17.51 11.58s12.87 6.65 19.78 5.54a4.56 4.56 0 0 1 .21.87l.58-.07c1.19 3.3-1.73 6.56-4.42 8.81-5.1 4.28-10.89 8.54-17.55 8.69-2.57.06-5.29-.49-7.63.58a6.81 6.81 0 0 0-1.42.9 34.1 34.1 0 0 1-10.43 33.58l15.38-5.63s.64.34 1.64 1L361.7 244s42.83-15.86 54.73 8.73-51.56 11.9-51.56 11.9l-13.58 7.59a12.78 12.78 0 0 1-1.49 8.27l-37 23.26c7.48 2.34 19.77 6.09 22 6.09 3.17 0 11.9 3.17 17.45 15.86s25.38 74.56 42.83 84.87 63.46 79.32 63.46 79.32l-.21.54q1.23.33 2.41.72c11.51 3.81 19.25 11.83 23.92 18.33a7.81 7.81 0 0 1-5.36 12.26c-18.16 2.33-28.08-6.17-32.85-12.6-.31-.42-.6-.83-.87-1.22a6.29 6.29 0 0 1-4.48.21l-22.28-18.23s17.38 17.39 7.19 33.23l.77 1.1A254.42 254.42 0 0 1 464 606.5s9.52 7.14 10.31 35.69 10.31 74.56 10.31 74.56 6.38 54.74 2.38 71.4c0 0-.46.66-1.3 1.68.3.36.62.74 1 1.15 3.46 3.8 9.71 9.05 17 7.49 11.11-2.38 11.11 17.45-4.76 19-10.22 1-30.29 5.66-43.3 8.84a9.18 9.18 0 0 1-11.31-9.89c.78-7.11 2.19-15.71 4.76-21.83.16-.38.32-.75.49-1.11-.47-.44-.93-.9-1.4-1.39 0 0 0-34.9-5.55-44.42 0 0-15.07-72.18-14.28-90.43C429 643 389.24 587.4 372 563.92l.14-.89c-4.42-6-7.22-9.68-7.22-9.68l-13.48 86.46s-6.35 19-14.28 29.35c0 0-34.11 65.84-38.07 86.46-3 15.64-9.2 24.88-12 28.44l1 1c3.61 3.36 8.94 6.74 15 5.45 11.11-2.38 11.11 17.45-4.76 19-10.22 1-30.29 5.66-43.3 8.84a9.18 9.18 0 0 1-11.31-9.89c.9-8.26 2.67-18.52 6.09-24.59q.43-.77.9-1.44a8.39 8.39 0 0 1-3.15-2.26s20.62-50 20.62-63.46c0 0 8.73-51.56 38.07-70.6 0 0-2.78-64.48-11.13-100.37q-.31-1.33-.63-2.6a232.41 232.41 0 0 1-23.14-4.9l-.79-23.8-4 19-44.46-27.68s.39-5 1.14-12.67c.38-3.84.84-8.34 1.4-13.22.44-3.9.95-8 1.5-12.28q.21-1.59.43-3.19c.58-4.27 1.22-8.6 1.91-12.83q.39-2.38.8-4.71c.36-2.07.74-4.1 1.13-6.08q.29-1.48.6-2.92t.62-2.82q.31-1.38.63-2.71l.32-1.31q.33-1.29.66-2.51a46.12 46.12 0 0 0 1.61-10.4q.08-2.1 0-4.19t-.4-4.17q-.14-1-.34-2.07a47.78 47.78 0 0 0-2.25-8.1q-.74-2-1.66-3.9c-1.44-3-3-6.25-4.56-9.67q-1.19-2.57-2.4-5.25t-2.44-5.44c-7.72-17.48-15.34-37-17.38-49.78-.21-1.35-.37-2.62-.45-3.81a25.85 25.85 0 0 1-.05-3.31z",
    transform: "translate(-96.78 -42.46)",
    fill: "url(#prefix__i)"
  }), React.createElement("path", {
    d: "M238.63 227.16l26.16-17.7s41.55-15.39 53.09 8.46-50 11.54-50 11.54l-26.16 14.62z",
    fill: "#f7bbc3"
  }), React.createElement("path", {
    d: "M161.22 766.6c12.62-3.08 32.09-7.58 42-8.57 15.39-1.54 15.39-20.77 4.62-18.46-5.84 1.25-11-2-14.51-5.29a34 34 0 0 1-3.05-3.26 8.89 8.89 0 0 0-5-3c-5.77-1.26-17.78-3.16-25.17.82a10.87 10.87 0 0 0-4 4.36c-3.32 5.89-5 15.84-5.91 23.85a8.9 8.9 0 0 0 11.02 9.55zM355.89 774.29c12.62-3.08 32.09-7.58 42-8.57 15.39-1.54 15.39-20.77 4.62-18.46-7 1.52-13.11-3.58-16.46-7.26-.41-.45-.78-.88-1.1-1.28a8.89 8.89 0 0 0-5-3c-5.77-1.26-17.78-3.16-25.17.82-2.16 1.17-3.89 3.73-5.27 7-2.49 5.94-3.86 14.28-4.62 21.17a8.9 8.9 0 0 0 11 9.58z",
    fill: "#535461"
  }), React.createElement("path", {
    d: "M349.53 743.54c18.37 18.93 34.12-.35 36.51-3.53-.41-.45-.78-.88-1.1-1.28a8.89 8.89 0 0 0-5-3c-5.77-1.26-17.78-3.16-25.17.82-2.13 1.1-3.86 3.67-5.24 6.99zM156.22 733.15c8 5.44 34.75 4.1 34.75 4.1a26.36 26.36 0 0 0 2.42-3 34 34 0 0 1-3.05-3.26 8.89 8.89 0 0 0-5-3c-5.77-1.26-17.78-3.16-25.17.82a10.87 10.87 0 0 0-3.95 4.34z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M154.77 729.54c5.39 6.92 36.16 5.39 36.16 5.39s9.23-9.23 13.08-29.24 36.93-83.86 36.93-83.86c7.69-10 13.85-28.47 13.85-28.47l13.08-83.82s63.08 83.07 62.35 100.77 13.85 87.71 13.85 87.71c5.39 9.23 5.39 43.08 5.39 43.08 20 20.77 36.93-3.85 36.93-3.85 3.85-16.16-2.31-69.24-2.31-69.24s-9.23-44.62-10-72.32-10-34.62-10-34.62a246.78 246.78 0 0 0-36.13-79.81c-4.73-6.65-7.73-10.21-7.73-10.21l-124.68 14.62c2 4 3.79 9.73 5.36 16.51 8.1 34.81 10.79 97.36 10.79 97.36-28.47 18.46-36.93 68.47-36.93 68.47.01 13.08-19.99 61.53-19.99 61.53z",
    fill: "#f88787"
  }), React.createElement("g", {
    opacity: 0.05
  }, React.createElement("path", {
    d: "M274.73 519.77l1.6-10.25s63.09 83.09 62.32 100.79 13.85 87.71 13.85 87.71c5.39 9.23 5.39 43.08 5.39 43.08 4.19 4.35 8.25 6.71 12 7.72-6.06 1.59-13.43.43-21.28-7.72 0 0 0-33.85-5.39-43.08 0 0-14.62-70-13.85-87.71.65-13.85-37.87-67.77-54.64-90.54z"
  }), React.createElement("path", {
    d: "M174 668.01s8.46-50 36.93-68.47c0 0-2.69-62.54-10.79-97.36-1.58-6.78-3.35-12.5-5.36-16.51l124.64-14.62s.29.34.82 1l-116.23 13.62c2 4 3.79 9.73 5.36 16.51 8.1 34.81 10.79 97.36 10.79 97.36-28.46 18.46-36.94 68.47-36.94 68.47 0 13.08-20 61.55-20 61.55 3.17 4.08 15.17 5.22 24.49 5.47-7.39.19-29.26.26-33.72-5.47.01-.02 20.01-48.47 20.01-61.55z"
  })), React.createElement("path", {
    d: "M343.22 460.28a27.86 27.86 0 0 0 3.65 6.37c4.63 6.23 14.25 14.48 31.87 12.22a7.57 7.57 0 0 0 5.2-11.89c-4.52-6.3-12-14.09-23.2-17.78a41.79 41.79 0 0 0-9.82-2z",
    fill: "#f7bbc3"
  }), React.createElement("path", {
    d: "M180.78 245.11l61.7-22.57s17.74 9.24 10.74 22.32l-60 37.68z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M180.78 245.11l61.7-22.57s17.74 9.24 10.74 22.32l-60 37.68z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M178.62 207.93s.77 36.16-15.39 48.47 46.93 19.23 46.93 19.23-10-36.93 0-56.16-31.54-11.54-31.54-11.54z",
    fill: "#f7bbc3"
  }), React.createElement("path", {
    d: "M195.54 485.67c2 4 3.79 9.73 5.36 16.51 74.41 11.36 126.2-19.59 126.2-19.59.28-.45.55-.89.8-1.33-4.68-6.65-7.68-10.21-7.68-10.21zM343.22 460.28a27.86 27.86 0 0 0 3.65 6.37c7.12-1.18 12.82-14.8 13.87-17.46a41.79 41.79 0 0 0-9.82-2z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M172.46 240.24l27.7 10 11.54 15.39s23.85 7.69 26.93 7.69 11.54 3.08 16.93 15.39 24.62 72.32 41.55 82.32 61.55 76.94 61.55 76.94-7.69 20.77-16.93 17.7l-21.51-17.7s16.93 16.93 6.92 32.31c0 0-63.09 37.7-150 14.62l-.77-23.08-3.85 18.46-43.08-26.93s3.78-49.65 10.78-74.93a45.66 45.66 0 0 0-3-31.88c-11.17-23.28-28.41-62.16-26.31-76.34 2.48-16.71 11.92-24 15.52-26.16a6.43 6.43 0 0 1 2.71-.9l14.08-1.36z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M219.78 317.54s15.39 71.55 32.31 83.09 62.32 48.47 63.86 54.63",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M226.7 315.25s15.39 71.55 32.31 83.09 62.32 48.47 63.86 54.63",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M212.09 265.24s-53.09-17.7-68.47-13.08",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.05
  }, React.createElement("path", {
    d: "M137.22 356.54c-11.17-23.28-28.41-62.16-26.31-76.34 2.48-16.71 11.92-24 15.52-26.16a6.43 6.43 0 0 1 2.71-.9l6-.6a6.32 6.32 0 0 0-1.78.73c-3.6 2.2-13 9.45-15.52 26.16-2.1 14.17 15.14 53.06 26.31 76.34a45.66 45.66 0 0 1 3 31.84c-7 25.28-10.81 74.94-10.81 74.94l37.1 23.19-.94 4.51-43.08-26.93s3.8-49.62 10.8-74.9a45.66 45.66 0 0 0-3-31.88zM150.15 251.01l-6.66.67 28.97-11.44 2.6.94-24.91 9.83z"
  })), React.createElement("path", {
    d: "M226.7 389.88s-23.85-13.08-31.54-10-36.16-.77-36.16-.77M181.31 217.54c.88-7.71-2.69-6.54-2.69-6.54s41.55-7.69 31.54 11.54c-2.5 4.82-3.75 10.74-4.22 16.92h-.39c-11.59.01-18.33-12.92-24.24-21.92z",
    opacity: 0.05
  }), React.createElement("circle", {
    cx: 205.55,
    cy: 203.31,
    r: 33.08,
    fill: "#f7bbc3"
  }), React.createElement("path", {
    d: "M169.45 213.09c-3-6.58-5.2-13.72-4.83-21s3.6-14.55 9.6-18.55c3.1-2.09 6.76-3.21 10-5.11 2.51-1.49 4.73-3.42 7.12-5.1a40.33 40.33 0 0 1 40.28-2.93c6.07 3 11.25 7.59 17 11.23s12.48 6.45 19.19 5.37c1.15 3.2-1.68 6.36-4.29 8.55-4.95 4.15-10.56 8.29-17 8.43-2.5.06-5.13-.48-7.4.57a10.62 10.62 0 0 0-3.78 3.51 68.76 68.76 0 0 0-7.85 13.31c-.86 1.93-1.74 4-3.52 5.17-3 1.9-6.83.32-10.35.18-5.48-.21-10.4 3.23-14.46 6.93s-7.91 7.9-13 9.85c-3.82 1.45-11.46 1.4-13.41-3.17-.73-1.72.67-5.41.38-7.52-.55-3.38-2.28-6.65-3.68-9.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M168.68 212.32c-3-6.58-5.2-13.72-4.83-21s3.6-14.57 9.6-18.61c3.1-2.09 6.76-3.21 10-5.11 2.51-1.49 4.73-3.42 7.12-5.1a40.33 40.33 0 0 1 40.28-2.93c6.07 3 11.25 7.59 17 11.23s12.48 6.45 19.19 5.37c1.15 3.2-1.68 6.36-4.29 8.55-4.95 4.15-10.56 8.29-17 8.43-2.5.06-5.13-.48-7.4.57a10.62 10.62 0 0 0-3.78 3.51 68.76 68.76 0 0 0-7.85 13.31c-.86 1.93-1.74 4-3.52 5.17-3 1.9-6.83.32-10.35.18-5.48-.21-10.4 3.23-14.46 6.93s-7.91 7.9-13 9.85c-3.82 1.45-11.46 1.4-13.41-3.17-.73-1.72.67-5.41.38-7.52-.55-3.32-2.28-6.59-3.68-9.66z",
    fill: "#a95f60"
  }), React.createElement("path", {
    d: "M771.72 749.15s22.57-4.51 28.59-10.53 33.1-16.55 36.11-9 40.62 33.1 15 37.62-60.18 6-67.71 3-11.99-21.09-11.99-21.09z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M851.46 764.41c-25.58 4.51-60.18 6-67.71 3-5.73-2.29-9.71-13.3-11.28-18.43l-.75.16s4.51 18.06 12 21.06 42.13 1.5 67.71-3c7.38-1.3 9.49-4.36 8.7-8.24-.6 2.58-3.17 4.48-8.67 5.45z",
    opacity: 0.2
  }));
};
UndrawOrganizePhotos.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawOrganizePhotos;